import {
  Component, OnInit, Input, HostListener,
  Output, EventEmitter, ViewChildren,
  QueryList, ViewChild, ElementRef
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl } from '@angular/forms';



import { StaticDataService } from '../../service/static-data.service';
import { RestDataService } from '../../service/rest-data.service';
import { Config } from '../../config/config';
import * as $ from 'jquery';
import { OnChanges, DoCheck, AfterContentInit, AfterContentChecked, OnDestroy, AfterViewInit } from '@angular/core';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { SnotifyService } from 'ng-snotify';
import { SharedDataService } from '../../service/shared-data.service';
import { Router, NavigationExtras } from '@angular/router';
import { TranslateService } from '../../service/translate.service';
import { forkJoin ,  Observable, Subject } from 'rxjs';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { DragulaService } from 'ng2-dragula';
import * as dragula from 'dragula';
import * as autoScroll from 'dom-autoscroller';
import { LocalstorageService } from '../../service/localstorage.service';
import { environment } from '../../../environments/environment';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { saveAs } from 'file-saver';


@Component({
  selector: '.listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.css']
})
export class ListingComponent implements OnInit, DoCheck, OnDestroy, AfterContentInit, AfterViewInit {
  agencyHide: string = "";
  snapdealEmbedList: any = [];
  cromaEmbedList: any=[];
  emptyList: boolean;
  minAusScore: any;
  selectedSuggestedResult: any;
  @Input()
  set pageId(page_string: string) {
    this.page_id = (page_string && page_string.trim()) ? page_string : '';
  }
  @Input() amazonAffiliatePhotoListing:boolean;
  @Input() amazonOrSnapdeal:string;
  @Input()
  set allApi(api_string: string) {
    this.api = (api_string && api_string.trim()) ? api_string : '';
  }
  @Input()
  set search_label(search_label: string) {
    this.placeHolderText = (search_label && search_label.trim()) ? search_label : '';
  }
  @Input()
  set searchApi(search_api_string: string) {
    this.search_api = (search_api_string && search_api_string.trim()) ? search_api_string : null;
  }
  @Input()
  set metaApi(meta_api_string: string) {
    this.meta_api = (meta_api_string && meta_api_string.trim()) ? meta_api_string : null;
  }
  @Input()
  set byAuthor(byAuthor_string: string) {
    this.by_Author = (byAuthor_string && byAuthor_string.trim()) ? byAuthor_string : null;
  }
  @Input()
  set photoListing(photoListing_string: string) {
    this.by_photoListing = (photoListing_string && photoListing_string.trim()) ? photoListing_string : null;
  }
  @Input()
  set suggestionApi(suggestion_api_string: string) {
    this.suggestion_api = (suggestion_api_string && suggestion_api_string.trim()) ? suggestion_api_string : null;
  }
  @Input()
  set classVar(class_var_string: string) {
    this.class_var = (class_var_string && class_var_string.trim()) ? class_var_string : null;
  }
  @Input()
  set ImageArray(ImageArray: string[]) {
    this.listImageArrayC = (ImageArray && (ImageArray.length > 0)) ? ImageArray : [];
  }
  @Input()
  set storyIdArray(storyIdArray: string[]) {
    this.relatedStoryArray = (storyIdArray && (storyIdArray.length > 0)) ? storyIdArray : [];
    if (this.relatedSelectedArray.length <= 0 && storyIdArray && (storyIdArray.length > 0)) {
      this.callAllStories(storyIdArray);
    }
  }
  @Input()
  set storyId(storyId_string: number) {
    this.story_Id = (storyId_string) ? storyId_string : null;
  }
  @Input()
  set photogallery(photogallery: boolean) {
    this.showPhotoGalleryListing = photogallery;
  }
  @Input()
  set videogallery(videogallery: boolean) {
    this.showVideoGalleryListing = videogallery;
  }

  @Input()
  set exclusionList(exclusionList: string[]) {
    // console.log(exclusionList);
    this.exclusionListArray = (exclusionList && (exclusionList.length > 0)) ? exclusionList : [];
  }
  @Input()
  set byAgency(byAgency_string: string) {
    this.byAgencyWire = (byAgency_string && byAgency_string.trim()) ? byAgency_string : null;
  }

  @Input()
  set bySource(bySource_string: string) {
    this.bySourceWire = (bySource_string && bySource_string.trim()) ? bySource_string : null;
  }
  @Input() domainWiseImageList: string;
  @Input() showPagination: boolean;
  @Input() sendImagesManagerFlag: boolean;
  @Input() imageSearch: boolean;
  @Input() view: string = 'gridView';
  @Input() RelatedStorySearch: boolean;
  @Input() multipleStories: boolean;
  @Output() sendIdToParentfn = new EventEmitter<any>();
  @Output() sendEventToParentfn = new EventEmitter<any>();
  @Output() sendListIdToParentfn = new EventEmitter<any>();
  @Output() sendIdVieoToParentfn = new EventEmitter<any>();
  @Output() sendPodcastToParentfn = new EventEmitter<any>();
  @Output() sendToClearImageList = new EventEmitter<any>();
  @Input() typesToPick: string;
  @Input() isPickEnabled: boolean;
  @Input() relatedStoryType: string;
  @Input() isCroma:boolean;
  @Output() sendRelatedStoryGalleryType = new EventEmitter<any>();
  defaultImagecardData = StaticDataService.defaultImageCardData;
  by_Author: string;
  by_photoListing: string;
  page_id: string;
  heightCalculated = true;
  story_Id: number;
  byAgencyWire: string;
  iframeStyle = null;
  class_var: string;
  api: string;
  suggestion_api: string;
  search_api: string;
  meta_api: string;
  suggestedItems= [];
  domainAll: any[];
  showPageNav = false;
  isPrintImagesEnabled = false;
  toggleScore = false;
  toggleImageType = false;
  toggleWidth = false;
  toggleLowQuality = false;
  minWidth : any;
  minHeight : any;
  minSize : any;
  lowQualityFilter : any;
  lowQualityFilterButton : any;
  showPhotoGalleryListing = true;
  showVideoGalleryListing = false;
  setCheck = false;
  type: string;
  valueChangeEvent = true;
  placeHolderText: string;
  listArray: any[] = [];
  listIdArray: any[] = [];
  listSuggestionArray: any[] = ['can','man','modi'];
  listSearchText: any[] = [];
  listImageArrayC: any[] = [];
  public pageNum = 0;
  lastScrollTop = 0;
  arrowkeyLocation = 0;
  offset = 5;
  public lastPageNum = -1;
  pageSize = 50;
  pageSizeArray = [10,50, 100, 150, 200];
  affiliateSizeArr=[10];
  pages = 34;
  currentRowSelected = 1;
  searchFocus = false;
  searchQuery: FormControl = new FormControl();
  headerList: any;
  filterList: any;
  videoSummary: string = '';
  storyData: any;
  embedCode = '';
  videoUrl = '';
  mas: any;
  iframeLoading = 0;
  openVideoPreview = false;
  facets: any;
  previewPlatform: any;
  wireImageIp: string;
  monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  public videoList = [];
  public authorFilterList = [];
  private model: any = null;
  previewUrl = null;
  isVideoStory = false;
  videoSrc: string;
  filterUrl = {};
  sortByValueOf: string;
  noresults = false;
  callFail = false;
  byField: string;
  byThumbnail = false;
  byWireThumbnail = false;
  byElemets = false;
  lightBoxP: string;
  viewPhoto: string;
  str: string = '';
  totalRecords: number;
  showLoader = false;
  requestInQueue = 0;
  videDesc: string;
  videoCreated: string;
  videoChannel: string;
  videoUsed: string;
  lastFiveStoriesUsedIn: any;
  tags: any;
  selectedItem: string = 'gridView';
  showMore = false;
  showSuggestionBox = false;
  routeLinkForList: string;
  wireImageDisplayUrl = this.config.get('product').wireImageDisplayUrl;
  mobile91DisplayUrl = 'https://images.hindustantimes.com/productimages/'
  wireImageUrl = this.config.get('product').wireImageUrl;
  relatedStoryArray: any[];
  relatedSelectedArray = [];
  private serverUrl = this.config.get('product').socketUrl;
  private title = 'WebSockets chat';
  private stompClient;
  mySet = new Set();
  currentWireItem = null;
  socketsAllowed = [];
  fields = [];
  unlockOptions = null;
  lockandPublishIconHeader = null;
  unlock_story_api = null;
  unlockPopup = false;
  lockedUser = '';
  lockedId = null;
  mapping_api = StaticDataService.related_domain_mapping;
  mapping_api_embed = StaticDataService.related_domain_mapping_embed;
  domainMapping = {};
  exclusionListArray;
  openWirePreview = false;
  wirePreviewStory = null;
  translatedPreviewStory = null;
  compareStory = false;

  initialUrl = '';
  latestUrl = '';
  exactMatch = false;
  targetLaguages: any[];
  domain = '';
  multiList = [];
  selectedView = 'gridView';
  type1: boolean;
  type2: boolean;
  type3: boolean;
  bySourceWire: string;

  videoLeadImage: string;
  videoDuration: string;
  isVideoModal = false;
  domainConfig: any;
  toggleArry = [];
  selectedItemAmazonList=[]
  selectedItemAffiliateList=[]
  selectedItemSnapdealList=[];
  selectedItemCromaList = [];
    checked:any=false;
    defaultRelatedStoryHowToFilter:any;
  @ViewChildren('listEl') listElements: QueryList<any>;
  @ViewChild('moreButtonEl',{static: false}) moreButton: ElementRef;
  @ViewChild('listingInput',{static: false}) searchInput: ElementRef;
  @ViewChildren('listingInput') searchField;
  @ViewChildren('unlockDropdown') unlockDropdown: QueryList<any>;
  @ViewChild('clipboardInput',{static: false}) clipboardInput: ElementRef;

  @ViewChildren('listData2') listData: ElementRef;
  @ViewChild('listSection',{static: false}) listSection: ElementRef;
  // @ViewChild('clipboardButton') clipboardButton: ElementRef;
  videoFeedDomains = '';
  hideListing = false;
  isAuthorIdEnabled = false;
  timings = {
    constr: 0,
    onin: 0,
    resp: 0,
    list: 0,
    getEnv: 0,
    getMeta: 0
  };
  amzonEmbedList=[];
  affiliateEmbedList = [];
  amzonEmbedSelectedList=[];
  selectedPodcastPublisher = null;

  selectedPublisherQuery = '';
  selectedPublisher = null;
  insidePublisher:boolean = false;
  insideSearchByKeyWord:boolean = false;
  filteredPublisherSuggestion: any[] = [];
  publisherSuggestion: any[] = [];

  podcastList: any[] = [];
  podcastEpisodesList: any[] = [];
  private http: HttpClient;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  ref = null;
  imageSearchBoxOptionEnable : boolean;
  constructor(
    private config: Config,
    private restService: RestDataService,
    private snotify: SnotifyService,
    private sharedService: SharedDataService,
    private translateService: TranslateService,
    private dragulaService: DragulaService,
    private _http: HttpClient,
    private httpBackend: HttpBackend,
    private sanitizer: DomSanitizer,
    private router: Router,
    private localstorageService:LocalstorageService
  ) {
    this.http = new HttpClient(httpBackend);
    console.log('constructor => 0');
    this.timings.constr = performance.now();
    this.domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    if (dragulaService.find('fifth-bag') == undefined) {
      dragulaService.dragend.subscribe(value => {
        this.sendIdToParentfn.emit({
          id: this.relatedSelectedArray.map(a => a.id),
          type: 'multiple'
        });
        this.dragend(value);
      });
      dragulaService.setOptions('fifth-bag', {
        moves: function (el, container, handle) {
          return (handle.className === 'actions' || handle.className === 'icon-move related-move');
        }
      });
    }
    //this.snotify.clear();
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
    // this.domainConfig = this.sharedService.currentDomainConfiguration; 
  }

  getDomainConfig(currentDomainConfig) {
    // console.log(currentDomainConfig);
    this.domainConfig = currentDomainConfig;
    this.videoFeedDomains = (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['videoFeed'] && this.domainConfig['config']['videoFeed']['domains']
      && this.domainConfig['config']['videoFeed']['domains'].trim() !== '') ?
      this.domainConfig['config']['videoFeed']['domains'].trim() : 'HT,LM';
    this.imageSearchBoxOptionEnable = this.domainConfig && this.domainConfig['config']
    && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['enableImageSearchboxOption']
    this.isAuthorIdEnabled = (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['authorId']
      && this.domainConfig['config']['story']['authorId'] === 'true');
    let mas = (this.domainConfig['config'] && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['minAusScore'] ? this.domainConfig['config']['image']['minAusScore'] : 2.49);
     this.minAusScore = Number(mas);
     console.log("MIN AUS SCORE", this.minAusScore)
     this.isPrintImagesEnabled = this.sharedService.isdomainConfig('image','printImage');
     this.minWidth =this.domainConfig['config']['image']['minWidth'] ? this.domainConfig['config']['image']['minWidth'] : 999;
     this.minHeight = this.domainConfig['config']['image']['minHeight'] ? this.domainConfig['config']['image']['minHeight'] : 799;
     this.minSize = this.domainConfig['config']['image']['minSize'] ? this.domainConfig['config']['image']['minSize'] : 99;
     this.lowQualityFilter = this.domainConfig['config']['image']['lowQualityFilter'] ? this.domainConfig['config']['image']['lowQualityFilter'] : false;
     this.lowQualityFilterButton = this.domainConfig['config']['image']['lowQualityFilterButton'] ? this.domainConfig['config']['image']['lowQualityFilterButton'] : false;
     this.ref = this.domainConfig['config']['story']['ref'] ? this.domainConfig['config']['story']['ref'] : null;
  }

  dragend(ev) {
    // console.log('dragend', ev);
    document.onmousemove = null;
  }

  callAllStories(ids) {
    for (let i = 0; i < ids.length; i++) {
      const id = ids[i];
      this.restService.http_get(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.story_page_id, StaticDataService.story_get_api)
        + '/' + id)
        .subscribe(
          data => {
            this.relatedSelectedArray[i] = data;
            // console.log(this.arrayIndex);
          },
          error => {
            // console.log(error);
          });
    }
  }

  initializeWebSocketConnection() {
    const ws = new SockJS(this.serverUrl
      + '?access_token='
      + JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).access_token);
    this.stompClient = Stomp.over(ws);
    this.stompClient.debug = false;
    const self = this;
    const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.stompClient.connect({}, function (frame) {
      if (self.socketsAllowed.indexOf(1) > -1) {
        console.log('story dashboard socket online!', domain);
        self.stompClient.subscribe('/topic/article-lock-' + domain, (message) => {
          const tempObj = JSON.parse(message.body);
          const j = self.listIdArray.indexOf(tempObj.articleId);
          if (j > -1 && self.listArray[j].id === tempObj.articleId && (self.initialUrl === self.latestUrl)) {
            self.listArray[j].lockedByUserId = tempObj.lockedByUserId;
            self.listArray[j].lockedByUserName = tempObj.lockedByUserName;
          }
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }

      if (self.socketsAllowed.indexOf(2) > -1) {
        console.log('story update socket online!');
        self.stompClient.subscribe('/topic/story-update-' + domain, (message) => {
          const bodyObj = JSON.parse(message.body);
          // console.log(bodyObj);
          if (bodyObj['type'] === 'story') {
            const j = self.listIdArray.indexOf(bodyObj.id);
            if ((j > -1) && (self.listArray[j].id === bodyObj.id) && (self.initialUrl === self.latestUrl)) {
              self.listArray[j] = bodyObj;
            }
            if (j < 0 && (self.initialUrl === self.latestUrl)) {
              self.listIdArray.unshift(bodyObj.id);
              self.listArray.unshift(bodyObj);
            }
          }
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }

      if (self.socketsAllowed.indexOf(3) > -1) {
        console.log('wire pick socket online!');
        self.stompClient.subscribe('/topic/feed-pick-' + domain, (message) => {
          const bodyObj = JSON.parse(message.body);
          const j = self.listIdArray.indexOf(bodyObj.id);
          if ((j > -1) && (self.listArray[j].id === bodyObj.id) && (self.initialUrl === self.latestUrl)) {
            self.listArray[j] = bodyObj;
            if (self.wirePreviewStory && (bodyObj.id === self.wirePreviewStory.id)) {
              self.wirePreviewStory = bodyObj;
            }
          }
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }

      if (self.socketsAllowed.indexOf(4) > -1) {
        console.log('wire publish socket online!');
        self.stompClient.subscribe('/topic/feed-publish-' + domain, (message) => {
          const bodyObj = JSON.parse(message.body);
          const j = self.listIdArray.indexOf(bodyObj.id);
          if ((j > -1) && (self.listArray[j].id === bodyObj.id) && (self.initialUrl === self.latestUrl)) {
            self.listArray[j] = bodyObj;
            if (self.wirePreviewStory && (bodyObj.id === self.wirePreviewStory.id)) {
              self.wirePreviewStory = bodyObj;
            }
          }
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }
      if (self.socketsAllowed.indexOf(5) > -1) {
        self.stompClient.subscribe('/topic/zone-lock-' + domain, (message) => {
          const tempObj = JSON.parse(message.body);
          const j = self.listIdArray.indexOf(tempObj.zoneId);
          if (j > -1 && self.listArray[j].id === tempObj.zoneId && (self.initialUrl === self.latestUrl)) {
            self.listArray[j].lockedByUserId = tempObj.lockedByUserId;
            self.listArray[j].lockedByUserName = tempObj.lockedByUserName;
          }
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }

      if (self.socketsAllowed.indexOf(6) > -1) {
        self.stompClient.subscribe('/topic/page-update-' + domain, (message) => {
          const bodyObj = JSON.parse(message.body);
          const j = self.listIdArray.indexOf(bodyObj.zoneId);
          if ((j > -1) && (self.listArray[j].id === bodyObj.zoneId) && (self.initialUrl === self.latestUrl)) {
            self.listArray[j] = bodyObj;
          }
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }
      if (self.socketsAllowed.indexOf(7) > -1) {
        self.stompClient.subscribe('/topic/story-delete-' + domain, (message) => {
          const bodyObj = JSON.parse(message.body);
          const j = self.listIdArray.indexOf(bodyObj);
          self.listArray.splice(j, 1);
          self.listIdArray.splice(j, 1);
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }
      if (self.socketsAllowed.indexOf(8) > -1) {
        self.stompClient.subscribe('/topic/story-update-' + domain, (message) => {
          const bodyObj = JSON.parse(message.body);
          if (bodyObj['type'] === 'element') {
            const j = self.listIdArray.indexOf(bodyObj.id);
            if ((j > -1) && (self.listArray[j].id === bodyObj.id) && (self.initialUrl === self.latestUrl)) {
              self.listArray[j] = bodyObj;
            }
            if (j < 0 && (self.initialUrl === self.latestUrl)) {
              self.listIdArray.unshift(bodyObj.id);
              self.listArray.unshift(bodyObj);
            }
          }
        },
          err => {
            // console.log('sorry could not subscribe to socket');
          });
      }
    },
      err => {
        console.log(err);
      });
  }

  onPageSizeChange(size) {
    this.pageNum = 0;
    this.pageSize = size;

    this.searchResults(this.searchQuery.value, this.pageNum, data => {
      this.listArray = [];
      this.listIdArray = [];
      this.multiList = [];
      if (data && data['content'] && data['content'].length > 0) {
        this.dataInsertion(data['content']);
        if (this.page_id === 'videoServiceStory') {
          this.multiList = this.createMultipleList(this.listArray);
        }
        this.noresults = false;
      } else {
        this.noresults = true;
      }
    });
  }

  toggleView(view) {
    if (view === 'gridView') {
      this.selectedView = 'gridView';
      setTimeout(e => {
        for (let i = 0; i < this.listImageArrayC.length; i++) {
          for (let j = 0; j < document.getElementsByClassName('imageblock').length; j++) {
            const el = this.closest(document.getElementById(this.listImageArrayC[i]['id']), '.imageblock');
            if (el && el.classList) {
              el.classList.toggle('selected');
              const imglibHeight = document.getElementsByClassName('imageblock')[i].children[0].clientHeight;
              const btnmargin = (imglibHeight - 38) / 2;
              $('.image .hover').css('height', imglibHeight + 'px');
              $('.image .hover button.blue').css('margin-top', btnmargin + 'px');
              $(this).toggleClass('z-high');
              break;
            }
          }
        }

      }, 50);
    } else {
      this.selectedView = 'listView';
      setTimeout(e => {
        for (let i = 0; i < this.listImageArrayC.length; i++) {
          for (let j = 0; j < document.getElementsByClassName('list').length; j++) {
            const el = this.closest(document.getElementById('p_' + this.listImageArrayC[i]['id']), '.list');
            if (el && el.classList) {
              el.classList.toggle('selected');
              break;
            }
          }

        }

      }, 50);
    }
  }

  appendSuggested(item) {
    if(item === this.selectedSuggestedResult) {
      this.selectedSuggestedResult = '';
      this.getsearchResults(this.str);
    } else {
      console.log(this.str + ' ' +item)
      this.selectedSuggestedResult = item;
      this.getsearchResults(this.str + ' ' + item)
    }
   
  }

  showNav(pageId) {
    if (this.toggleArry.indexOf(pageId) > -1)
      this.toggleArry.pop();
    else {
      this.toggleArry.pop();
      this.toggleArry.push(pageId);
    }
    // $('#page_' + pageId).toggleClass('active');
  }
  onPageNumberChange(pagenum) {
    this.pageNum = pagenum;
    this.searchResults(this.searchQuery.value, this.pageNum, data => {
      this.listArray = [];
      this.listIdArray = [];
      this.multiList = [];
      if (data && data['content'] && data['content'].length > 0) {
        this.dataInsertion(data['content']);
        if (this.page_id === 'videoServiceStory') {
          this.multiList = this.createMultipleList(this.listArray);
        }
        this.noresults = false;
      } else {
        this.noresults = true;
      }
    });
  }
  arrayOne(n: number) {
    return Array(n);
  }

  openOptions(index) {
    if (this.page_id === 'pages') {
      const storyStatus = this.listArray[index].status;
      if (this.listArray[index].lockedByUserId) {
        this.openUnlock(index);
        this.unlockOptions = null;
      }
    } else if (this.listArray[index].articleType === 'story') {
      const storyStatus = this.listArray[index].metadata.status;
      if (this.listArray[index].type !== 'video') {
        if (storyStatus === 'PUBLISHED' && this.listArray[index].lockedByUserId) {
          if (this.unlockOptions === index) {
            this.unlockOptions = null;
          } else {
            this.unlockOptions = index;
          }
        } else if (storyStatus === 'PUBLISHED' && !this.listArray[index].lockedByUserId) {
          this.unlockOptions = null;
          this.copyUrl(index);
        } else if (storyStatus !== 'PUBLISHED' && this.listArray[index].lockedByUserId) {
          this.openUnlock(index);
          this.unlockOptions = null;
        }
      } else {
        if (storyStatus === 'PUBLISHED') {
          const id = this.listArray[index].elements[0];
          if (this.unlockOptions === index) {
            this.unlockOptions = null;
          } else {
            this.restService.http_get(
              this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
              + '/' + id
            )
              .subscribe(result => {
                // console.log(result);
                if (!result.hasOwnProperty('error') && result.video.body !== null) {
                  const embed = result.video.body;
                  this.clipboardInput.nativeElement.value = embed;
                }
              });
            this.unlockOptions = index;
          }
        } else if (storyStatus !== 'PUBLISHED' && this.listArray[index].lockedByUserId) {
          this.openUnlock(index);
          this.unlockOptions = null;
        }
      }
    }
  }

  openUnlock(index) {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    const role = localStorage.getItem(StaticDataService.tokenLiteral) ?
      JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role
      : null;
    if (role && (role !== 'ROLE_ADMIN' && role !== 'ROLE_SUPER_ADMIN'  && role !== 'ROLE_EDITOR' && role!=='ROLE_SITE_MANAGER')) {
      this.snotify.warning('You don’t have permission to unlock', '', this.sharedService.getConfig(false));
    } else {
      this.unlockPopup = true;
      this.sharedService.overflowhidden();
      this.lockedUser = this.listArray[index].lockedByUserName;
      this.lockedId = this.listArray[index].id;
    }
  }

  addVideo(url) {
    this.videoUrl = url != null || url != undefined ? url : null;
    if (this.videoUrl && this.videoUrl !== null && this.videoUrl.trim() !== '') {
      if (!this.sharedService.isEmbedStripEnabled() && this.page_id !== 'videoServiceStory') {
        this.videoUrl = this.videoUrl.substring(this.videoUrl.indexOf("<iframe"), this.videoUrl.indexOf("</div"));
      }
      const videoCard = JSON.parse(JSON.stringify(StaticDataService.defaultVideoCardData));
      videoCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      if (this.videoUrl.indexOf('src="//players.brightcove.net') > -1) {
        if (this.videoUrl.split('src="') && this.videoUrl.split('src="') !== null && this.videoUrl.split('src="').length > 1) {
          if (this.videoUrl.split('src="')[1].split('"')[0].charAt(0) === '/') {
            videoCard.video.embedUrl = 'https:' + this.videoUrl.split('src="')[1].split('"')[0];
            videoCard.video.body = this.videoUrl.replace('src="', 'src="https:');
          } else {
            videoCard.video.embedUrl = this.videoUrl.split('src="')[1].split('"')[0];
            videoCard.video.body = this.videoUrl;
          }
        }
      } else if (this.videoUrl.indexOf('src=\'//players.brightcove.net') > -1) {
        if (this.videoUrl.split('src=\'') && this.videoUrl.split('src=\'') !== null && this.videoUrl.split('src=\'').length > 1) {
          if (this.videoUrl.split('src=\'')[1].split('\'')[0].charAt(0) === '/') {
            videoCard.video.embedUrl = 'https:' + this.videoUrl.split('src=\'')[1].split('\'')[0];
            videoCard.video.body = this.videoUrl.replace('src=\'', 'src=\'https:');
          } else {
            videoCard.video.embedUrl = this.videoUrl.split('src=\'')[1].split('\'')[0];
            videoCard.video.body = this.videoUrl;
          }
        }
      } else {
        if (this.videoUrl.indexOf('src="') > -1) {
          videoCard.video.embedUrl = this.videoUrl.split('src="')[1].split('"')[0];
          videoCard.video.body = this.videoUrl;
        } else if (this.videoUrl.indexOf('src=\'') > -1) {
          videoCard.video.embedUrl = this.videoUrl.split('src=\'')[1].split('\'')[0];
          videoCard.video.body = this.videoUrl;
        } else {
          this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
          return false;
        }
      }
      if (this.videoUrl.trim() !== '') {
        this.increasePendingCount();
        if (this.openVideoPreview) {
          this.iframeStyle = this.sanitizer.bypassSecurityTrustStyle('width:100%;height:96vh;border:none;position:relative;z-index:21;');
          this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videoCard.video.embedUrl);
          return;
        }
        this.videoList = [];
        this.multiList = [];
        const fd = new FormData();
        fd.set('file', this.videoLeadImage);
        videoCard.metadata.videoMetadata = {};
        videoCard.metadata.videoMetadata.duration = this.videoDuration;
        const leadImage = this._http.post(this.config.get('product').imageUploadUrl
          + this.config.get('product').imageUploadByUrlEndPoint, fd);

        const element = this._http.post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'), videoCard);

        forkJoin([leadImage, element]).subscribe(responseList => {
          const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
          defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
          defaultImagecardData.id = null;
          defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
          defaultImagecardData.image.caption = '';
          defaultImagecardData.image.images['original'] = responseList[0]['images']['original'];
          const story = JSON.parse(JSON.stringify(StaticDataService.defaultStoryData));
          story.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
          story.type = 'video';
          story.elements = [responseList[1]['id']];
          story.metadata.tags = this.tags ? this.tags : [];
          story.headline = this.videDesc;
          story.mobileHeadline = this.videDesc;
          story.urlHeadline = this.videDesc;
          story.summary = this.videoSummary;
          story.title = this.videDesc;
          this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
            defaultImagecardData, result => {
              if (!result.hasOwnProperty('error')) {
                this.decreasePendingCount(null);
                story.leadMedia.elements = [result.id];
                this.restService.http_post(this.config.get('product').baseUrl
                  + this.config.getEndPoint(this.config.get('views'), 'story_main', 'save_story'),
                  story, result2 => {
                    this.videoPickEvent('/dash/story/' + result2['id']);
                    this.router.navigate(['/dash/story/' + result2['id']]);
                  });
              }
            });
        });
      }
    } else {
      this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
    }
  }


  openVideoModal(video, $event) {
    this.isVideoModal = true;
    const url = this.router.routerState.snapshot.url;
    if (this.page_id === 'videoStory') {
      this.sharedService.analyticsCall((window.location.origin + url), 'Video Service', [], 'preview');
    } else if (this.page_id === 'videoServiceStory') {
      this.sharedService.analyticsCall((window.location.origin + url), 'Video Stories', [], 'preview');
    }
    if (video) {
      this.openVideoPreview = true;
      if (video.type && video.type === 'video' && video.articleType === 'story') {
        if (video.leadMedia.video) {
          if (video.leadMedia.video.body) {
            this.addVideo(video.leadMedia.video.body);
            this.embedCode = video.leadMedia.video.body;
          }
        }
        this.videDesc = video.mobileHeadline;
        this.videoCreated = video.createdDate;
        this.tags = video.metadata.tags;

      } else {
        this.addVideo(video.standardEmbedCode);
        this.embedCode = video.standardEmbedCode;
        this.videDesc = video.name;
        this.videoCreated = video.created_at;
        this.tags = video.tags || [];
        this.videoSummary = video.description || '';
        this.videoChannel = video.custom_fields.site_name || '';
        this.videoLeadImage = video.images.img_720;
        this.videoDuration = video.duration;

      }
      this.openVideoPreview = true;
      this.sharedService.overflowhidden();
    }
    $event.stopPropagation();
  }
  insertVideo() {
    this.openVideoPreview = false;
    this.addVideo(this.embedCode);
  }

  routeToLink(id) {
    if (this.routeLinkForList !== 'false' && this.isVideoModal === false) {
      this.router.navigate([this.routeLinkForList + '/' + id]);
    }
  }

  editVideo(video) {
    if (video) {
      // cdn.jwplayer.com
      const newCode = this.sharedService.checkEmbed(video.standardEmbedCode);
      // this.sharedService.isEmbedStripEnabled() ?
      // ('<iframe src="' + video.standardEmbedCode.split('iframe src="')[1].split('"')[0] + '"></iframe>')
      // : video.standardEmbedCode;
      this.embedCode = newCode;
      this.videDesc = video.name;
      this.videoCreated = video.created_at;
      this.tags = video.tags;
      this.videoSummary = video.description;
      this.videoChannel = (video.custom_fields && video.custom_fields.site_name) ? video.custom_fields.site_name : '';
      this.videoLeadImage = (video.images && video.images.img_720) ? video.images.img_720 : '';
      this.videoDuration = video.duration;
      this.addVideo(newCode);
    }
  }

  iframeLoaded(ev) {
    this.iframeLoading += 1;
  }
  closeVideoPreview() {
    this.previewUrl = null;
    this.previewPlatform = null;
    this.openVideoPreview = false;
    this.iframeLoading = 0;
    this.isVideoModal = false;
    this.sharedService.overflowauto();
  }
  increasePendingCount() {
    // console.log('increase => ' + this.id);
    this.requestInQueue += 1;
  }
  decreasePendingCount(counts) {
    // console.log('decrease => ' + this.id, counts);
    if (this.requestInQueue > 0) {
      if ((counts !== null) && (counts >= this.requestInQueue)) {
        this.requestInQueue = 0;
      } else {
        this.requestInQueue -= 1;
      }
    }
  }

  cancelUnlock() {
    this.unlockPopup = false;
    this.lockedUser = '';
    this.lockedId = null;
    this.sharedService.overflowauto();
  }

  unlockStory() {
    this.unlockPopup = false;
    this.sharedService.overflowauto();
    let unlockId = null;
    if (this.page_id === 'pages') {
      this.unlock_story_api = StaticDataService.page_unlock_api;
      unlockId = '?pageId=';
    } else {
      this.unlock_story_api = StaticDataService.story_unlock_api;
      unlockId = '?articleId=';
    }
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.unlock_story_api)
      + unlockId
      + String(this.lockedId)
    )
      .subscribe(
        data => {
          this.lockedUser = '';
          this.lockedId = null;
          this.snotify.success((this.page_id === 'pages' ? 'Page' : 'Story') + ' Unlocked', '', this.sharedService.getConfig(false));
        },
        error => {
          // console.log('Couldn\'t unlock story');
        });

    this.sharedService.overflowauto();
  }

  copyEmbed(inputElement) {
    if (inputElement.value.trim() !== '') {
      inputElement.select();
      document.execCommand('copy');
      inputElement.setSelectionRange(0, 0);
      inputElement.value = '';
      this.snotify.info('Video Embed copied to Clipboard', '', this.sharedService.getConfig(false));
    } else {
      this.snotify.error('Something bad happened', '', this.sharedService.getConfig(false));
    }
  }

  copyUrl(index) {
    const url = this.listArray[index].metadata.url;
    if (url.charAt(0) === '/') {
      this.copyFunction(this.sharedService.currentDomainUrl + url);
    } else {
      this.copyFunction(url);
    }
    this.snotify.info('URL copied to Clipboard', '', this.sharedService.getConfig(false));
  }

  copyFunction(text) {
    let selBox = document.createElement('textarea');
    selBox.value = String(text);
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
  startScroll() {
    if (this.listSection && this.listSection !== null) {
      const scroll = autoScroll([
        this.listSection.nativeElement
      ], {
        margin: 30,
        maxSpeed: 20,
        scrollWhenOutside: true,
        autoScroll: function () {
          return this.down;
        }
      });
    } else {
      setTimeout(e => {
        this.startScroll();
      }, 1000);
    }
  }

// // defaultRelatedStoryHowToFilter
  ngOnInit() {
    this.filterUrl=[];
    if(this.page_id == 'photoListing' && this.lowQualityFilter){
    var ev =  {type: 'image.width,image.height,image.size', data: ',image.width>'+this.minWidth+',image.height>'+this.minHeight+',image.size>'+this.minSize}
    this.urlUpdate(ev);
    }
    this.mas = (this.domainConfig['config'] && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['minAusScore'] ? this.domainConfig['config']['image']['minAusScore'] : 2.49);
    this.minAusScore = Number(this.mas);
    console.log('page_id ::: ' , this.page_id);
    if(this.page_id == 'podcast') {
      this.publisherSuggestion = JSON.parse(localStorage.getItem('podcastPublisherList'));
      this.filteredPublisherSuggestion = this.publisherSuggestion;
      console.log('publisherSuggestion :: ', this.publisherSuggestion);
      if(localStorage.getItem('domainConfig')) {
        const domainId = sessionStorage.getItem('domainId');
        const domainDetails = JSON.parse(localStorage.getItem('domainConfig'));
        const defaultPublisher = JSON.parse(domainDetails[domainId]['config']['podcast']['defaultPublisher']);
        this.selectedPodcastPublisher = defaultPublisher;
        this.selectPublisher(defaultPublisher, false);
        this.selectedPublisherQuery = defaultPublisher['name'];
        this.selectedPublisher = defaultPublisher;
        console.log('this.selectedPublisherQuery :: ', this.selectedPublisherQuery);
      }
    }
    this.defaultRelatedStoryHowToFilter=this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']  && this.domainConfig['config']['story']['defaultRelatedStoryHowToFilter'];

    this.sharedService.getData().subscribe(x => {
      if (x === 'listing_disable|true') {
        this.hideListing = true;
      } else if (x === 'listing_disable|false') {
        this.hideListing = false;
      }
    });
    this.startScroll();
    const drake = dragula();
    let bag: any = this.dragulaService.find('fifth-bag');
    if (bag === undefined && this.page_id === 'all_related_stories') {
      this.dragulaService.add('fifth-bag', drake);
      bag = this.dragulaService.find('fifth-bag');
    }
    if (bag === undefined && this.page_id === 'all_related_stories_embed') {
      this.dragulaService.add('fifth-bag', drake);
      bag = this.dragulaService.find('fifth-bag');
    }
    this.domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.domainAll = JSON.parse(localStorage.getItem(StaticDataService.domains_all));
    if (localStorage.getItem(StaticDataService.domains_all)) {
      for (let i = 0; i < this.domainAll.length; i++) {
        if (this.domainAll[i]['id'] === this.domain) {
          this.targetLaguages = Object.entries(JSON.parse(localStorage.getItem(StaticDataService.domains_all))[i]['languages'])
            .map(([name, id]) => ({ name, id }));
          // console.log(this.targetLaguages);
          for (const lang of this.targetLaguages) {
            if (lang.id === 'en') {
              this.type1 = true;
            } else if (lang.length === 1) {
              this.type2 = true;
            } else {
              this.type3 = true;
            }
          }
        }
      }

    }

    const headers = this.config.getHeaders(this.config.get('views'), this.page_id);
    this.headerList = ((headers === 'false') ? [] : headers);
    this.routeLinkForList = this.config.getKeyInView(this.config.get('views'), this.page_id, 'list_router');
    if (this.headerList && this.headerList.length > 0) {
      for (const header of this.headerList) {
        if (header.hasOwnProperty('sortDataBy') && header.sortDataBy) {
          this.sortByValueOf = header.sortByValue;
        } else if (header.hasOwnProperty('byField') && header.byField) {
          this.byField = header.model_id;
          this.sortByValueOf = header.sortByValue;
        } else if (header.hasOwnProperty('bythumbnail') && header.bythumbnail) {
          this.byField = 'image';
          this.byThumbnail = true;
          this.sortByValueOf = header.sortByValue;
        } else if (header.hasOwnProperty('bywirethumbnail') && header.bywirethumbnail) {
          this.byWireThumbnail = true;
          // console.log(document.getElementsByClassName("searchBlock"));
          // document.getElementsByClassName("searchBlock")[0]['style'].display = 'none';
          // document.getElementsByClassName("searchBlock")[0].insertAdjacentElement('beforebegin', document.getElementsByClassName("searchBlock")[1]);
        } else if (header.hasOwnProperty('bytype') && header.bytype) {
          // this.byField = 'paragraph';
          this.byElemets = true;
        }
        if (!header.colorCondition && header.conditionOn) {
          this.lockandPublishIconHeader = header;
        }
      }

    }

    if (localStorage.getItem('domainConfig')) {
      const domains = JSON.parse(localStorage.getItem('domainConfig'));
      for (let domain in (domains)) {
        if (domains[domain]['config']['jsonfeed']['print_feed']) {
          this.agencyHide = this.agencyHide + ",agency!" + domains[domain]['config']['jsonfeed']['print_feed'];
        }
      }
    }
    if (this.searchInput) {
      this.searchInput.nativeElement.focus();
    }
    if (this.suggestion_api) {
      if (this.valueChangeEvent) {
        this.searchQuery.valueChanges
          .pipe(debounceTime(1200)
          ,distinctUntilChanged())
          .subscribe(result => {
            this.getautoSuggestion(result, this.suggestion_api, data => {
              this.listSuggestionArray = [];
              const dataSuggestion = data;
              if (dataSuggestion && dataSuggestion.length > 0) {
                for (let i = 0; i < dataSuggestion.length; i++) {
                  this.listSuggestionArray.push(dataSuggestion[i]);
                }
                this.showSuggestionBox = true;
              } else {
                this.showSuggestionBox = false;
              }
            });
          });
      }
    } else if (this.page_id === 'videoStory') {
      this.searchQuery.valueChanges
        .pipe(debounceTime(1200)
        ,distinctUntilChanged())
        .subscribe(result => {
          this.searchResults(result, 0, data => {
            this.pageNum = 0;
            this.multiList = [];
            if (data && data['content'] && data['content'].length > 0) {
              if (this.page_id === 'videoServiceStory') {
                this.multiList = this.createMultipleList(this.listArray);
              }
              this.noresults = false;
            } else {
              this.noresults = true;
            }
          });
        });
    } else {
      this.searchQuery.valueChanges
        .pipe(debounceTime(1200)
        ,distinctUntilChanged())
        .subscribe(result => {
          this.searchResults(result, 0, data => {
            this.pageNum = 0;
            this.listArray = [];
            this.suggestedItems = [];
            this.getSuggestedImages(this.searchQuery);
            if(this.imageSearch) {
              this.getAutoSuggestionsForImage(result, data => {
                this.listSuggestionArray = [];
              const dataSuggestion = data;
              if (dataSuggestion && dataSuggestion.length > 0) {
                for (let i = 0; i < dataSuggestion.length; i++) {
                  this.listSuggestionArray.push(dataSuggestion[i]);
                }
                this.showSuggestionBox = true;
              } else {
                this.showSuggestionBox = false;
              }
              })
            }
            this.listIdArray = [];
            this.multiList = [];
            if (data && data['content'] && data['content'].length > 0) {
              this.dataInsertion(data['content']);
              if (this.page_id === 'videoServiceStory') {
                this.multiList = this.createMultipleList(this.listArray);
              }
              this.noresults = false;
            } else {
              this.noresults = true;
            }
          });
        });
    }

    if (!this.RelatedStorySearch) {
      this.socketsAllowed = this.config.getKeyInView(this.config.get('views'), this.page_id, 'socketCodes');
      if(this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['socket'] && this.domainConfig['config']['socket']['enableSocket'] && this.domainConfig['config']['socket']['enableSocket'] === 'true')
      {
        this.initializeWebSocketConnection();
      }
    }
    this.checkForMapping();
    const filters = this.config.getFilters(this.config.get('views'), this.page_id);
    console.log("filters",filters)
    this.filterList = this.sharedService.getUpdatedFilters(filters);
    // console.log('we dont need filter for gallery type related story');
    if(this.relatedStoryType=='gallery' || this.relatedStoryType=='howto' || this.relatedStoryType=='video' || this.relatedStoryType=='web-story'){
      this.filterList=[];
    }
    if (this.meta_api && this.meta_api.trim() !== '') {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.meta_api)

        
      )
        .subscribe(data => {
          this.facets = {...data, ...this.facets};
          // console.log('this.facets',this.facets)
        });
      // let metaData=this.localstorageService.getMetaData();
      // console.log('all-element-listing.componet metadata',metaData);
      // this.facets=metaData; 
    }

    if (this.page_id === 'pages' || this.page_id === 'element' || this.page_id === 'all_stories' || this.page_id === 'my_workspace') {
      this.fields = [];
      for (let i = 0; i < this.headerList.length; i++) {
        if (this.headerList[i].model_id !== null) {
          this.fields.push(this.headerList[i].model_id.replace('[0]', ''));
        }
      }
    }
    if (this.page_id === 'videoServiceStory' || this.page_id === 'videoStory') {
      this.isVideoStory = true;
      if (!this.facets) {
        this.facets = {};
      }
      this.facets['sitename'] = {};
      const sites = this.videoFeedDomains.split(',');
      sites.forEach(site => {
        this.facets['sitename'][site] = 1;
      });
      // console.log(this.facets);
    } else {
      this.isVideoStory = false;
    }
  }
  getAutoSuggestionsForImage(query, callback) {
    const tempQuery = query;
    this.str = tempQuery;
    query = query.split(' ');
    query = query[(query.length - 1)];
    if (query && query.length > 2 && this.valueChangeEvent) {
      this.showSuggestionBox = false;
      const url = this.config.get('product').baseUrl
        + '/api/cms/image/autoComplete'
        + '?text=' + StaticDataService.encodeSpecialChar(tempQuery);
        console.log("first" + url)
      this.restService.http_get(url)
        .subscribe(data => {
          callback(data);
        },
          error => {
            // console.log(error);
          });
    }
  }

  getImageDownloadFlag() {
    return (this.domainConfig && this.domainConfig.config
      && this.domainConfig.config.image && this.domainConfig.config.image.download
      && this.domainConfig.config.image.download === 'true');
  }
  getDownloadImageManagerFlag() {
    return this.sendImagesManagerFlag;
  }

  setView(view) {
    if (view == 'gridView') {
      this.selectedItem = 'gridView';
    }
    if (view == 'listView') {
      this.selectedItem = 'listView';
    }
  }

  setFocusListItem(id) {
    this.currentWireItem = id;
  }

  ngAfterContentInit() {


  }

  ngAfterViewInit() {

  }



  ngDoCheck() {
    if (this.heightCalculated && document.getElementsByClassName('lightContent')[0] && document.getElementsByClassName('lightContent')[0].children[3]
      && document.getElementsByClassName('lightContent')[0].children[3].children[0] && document.getElementsByClassName('lightContent')[0].children[3].children[0].getElementsByTagName('iframe')[0]
      && document.getElementsByClassName('lightContent')[0].children[3].children[0].getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0]) {
      let height = document.getElementsByClassName('lightContent')[0].children[3].children[0].getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0].clientHeight + 70;
      document.getElementsByClassName('lightContent')[0].children[3].setAttribute('style', 'height:' + height + 'px;');
      // console.log(height);
      height = 0;
      this.heightCalculated = false;
      // console.log('init called');
    }

    /*  if(document.getElementsByTagName('ng2-pdfjs-viewer')[0] && document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0]){
       const height = document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0].clientHeight;
       console.log("height of pdf.."+height);
       document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0].setAttribute('style','height:'+ height + 'px;');
       const width = document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0].clientWidth;
       console.log(width);
       document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0].setAttribute('style','width:'+ width + 'px;');
     } */
  }



  checkFocusInside(elem) {
    if (elem && elem.contains(document.activeElement)) {
      return true;
    } else {
      return false;
    }
  }

  openPreviewIfFocused(ev, el, item) {
    const key = ev.keyCode || ev.charCode;
    const focusedElement: HTMLElement = document.activeElement as HTMLElement;
    if (key === 13 && !ev.shiftKey && this.checkFocusInside(el)) {
      this.openPreview(item);
    }
  }

  toggleSwitch(model) {
    var ev;
    if (model === 'exact') {
      this.exactMatch = !this.exactMatch;
      this.searchResults(this.searchQuery.value, this.pageNum, data => {
        this.listArray = [];
        this.listIdArray = [];
        this.multiList = [];
        if (data && data['content'] && data['content'].length > 0) {
          this.dataInsertion(data['content']);
          if (this.page_id === 'videoServiceStory') {
            this.multiList = this.createMultipleList(this.listArray);
          }
          this.noresults = false;
        } else {
          this.noresults = true;
        }
      });
      // console.log(this.exactMatch);
    }
    if(model === 'AusScore'){
      this.toggleScore = !this.toggleScore
      if(this.toggleScore){
       ev =  {type: 'image.ausScore', data: ',image.ausScore>'+this.minAusScore}
      this.urlUpdate(ev);
      }
      else{
        ev = {type: 'image.ausScore', data: ''}
        this.urlUpdate(ev);
      }
    }
    if(model === 'imageType'){
      this.toggleImageType = !this.toggleImageType
      if(this.toggleImageType){
        if(this.toggleLowQuality == false){
          delete this.filterUrl['image.width,image.height,image.size'];
          ev =  {type: 'image.images.imageSource', data: ',image.images.imageSource:Print'}
          this.urlUpdate(ev);
        }
        else{
          ev = {type: 'image.images.imageSource', data: ',image.images.imageSource:Print'}
          this.urlUpdate(ev);  
        }
      }
      else{
        if(this.toggleLowQuality == false){
          delete this.filterUrl['image.images.imageSource'];
          if(this.lowQualityFilter){
          ev =  {type: 'image.width,image.height,image.size', data: ',image.width>'+this.minWidth+',image.height>'+this.minHeight+',image.size>'+this.minSize}
          this.urlUpdate(ev);
          }else{
            ev = {type: 'image.images.imageSource', data: ''}
            this.urlUpdate(ev);
          }
        }
        else{
          ev =  {type: 'image.images.imageSource', data: ''}
          this.urlUpdate(ev);
        }
      }
    }
    if(model === 'width'){
      this.toggleWidth = !this.toggleWidth
      if(this.toggleWidth){
        ev =  {type: 'image.width', data: ',image.width>999'}
        this.urlUpdate(ev);
      }
      else{
        ev =  {type: 'image.width', data: ''}
        this.urlUpdate(ev);
      }
    }
    if(model === 'lowQuality'){
      this.toggleLowQuality = !this.toggleLowQuality
      if(this.toggleLowQuality){
        ev =  {type: 'image.width,image.height,image.size', data: ''}
        this.urlUpdate(ev);
      }
      else{
        ev =  {type: 'image.width,image.height,image.size', data: ',image.width>'+this.minWidth+',image.height>'+this.minHeight+',image.size>'+this.minSize}
        this.urlUpdate(ev);
      }
    }
  }

  callToggles(ev, model) {
    const key = ev.keyCode || ev.charCode;
    if (key === 13) {
      ev.preventDefault();
      this.toggleSwitch(model);
      ev.stopPropagation();
    }
  }



  @HostListener('window:keydown', ['$event'])
  public hotkeys(event) {
    const key = event.keyCode || event.charCode;
    switch (key) {
    case 27:
      if (this.openWirePreview) {
        this.closePreview();
      }
      if (this.openVideoPreview) {
        this.openVideoPreview = false;
      }
      // $('.revertStoryBlock pagenavdrop').removeClass('active');
      if (this.unlockPopup) {
        this.cancelUnlock();
      }
      this.unlockOptions = null;
      break;
    case 13:
      if (this.moreButton && (document.activeElement === this.moreButton.nativeElement)) {
        // console.log('entr on more');
        this.showMore = !this.showMore;
      }
      break;
    }
  }

  checkForMapping() {
    if (this.page_id === 'all_related_stories') {
      const url = this.config.get('product').domainUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.mapping_api);
      this.restService.http_get(url)
        .subscribe(data => {
          for (const item of data) {
            this.domainMapping[item.id] = item.name;
          }
        });
    }
    if (this.page_id === 'all_related_stories_embed') {
      const url = this.config.get('product').domainUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.mapping_api_embed);
      // console.log(url);
      this.restService.http_get(url)
        .subscribe(data => {
          for (const item of data) {
            this.domainMapping[item.id] = item.name;
          }
          console.log("DOMAIN MAPPING",url , this.domainMapping)
        });
    }
  }
  @HostListener('document:click', ['$event'])
  handleClick(event) {

    const clickedComponent = event.target;
    if (this.valueChangeEvent) {
      if (this.searchField && this.searchField['_results'][0] && clickedComponent === this.searchField['_results'][0].nativeElement) {

      } else {
        this.listSuggestionArray = [];
      }
    }
    if (this.unlockDropdown && this.unlockOptions !== null) {
      for (let i = 0; i <= this.unlockDropdown['_results'].length; i++) {
        const j = i;
        if ((j < this.unlockDropdown['_results'].length) && this.unlockDropdown['_results'][j].nativeElement.contains(clickedComponent)) {
          break;
        }
        if (j === this.unlockDropdown['_results'].length) {
          setTimeout(e => {
            this.unlockOptions = null;
          }, 100);
        }
      }
    }
  }

  onHovering(e) {
    const imglibHeight = e.target.offsetHeight;
    const btnmargin = (imglibHeight - 38) / 2;
    $('.image .hover').css('height', imglibHeight + 'px');
    $('.image .hover button.blue').css('margin-top', btnmargin + 'px');
    $(this).toggleClass('z-high');
  }

  dataInsertion(data) {
    if (!this.RelatedStorySearch) {
      for (let i = 0; i < data.length; i++) {
        this.listArray.push(data[i]);
        if (data[i].id !== null) {
          this.listIdArray.push(data[i].id);
        }
      }
    } else {
      for (let i = 0; i < data.length; i++) {
        if (this.relatedStoryArray.indexOf(data[i].id) < 0) {
          this.listArray.push(data[i]);
          if (data[i].id !== null) {
            this.listIdArray.push(data[i].id);
          }
        }
      }
    }

    // this.listArray.findIndex(item => item.id === ev.id)
  }
  getDefaultList(pageNum, callback) {
    if (this.page_id === 'videoStory') {
      const header = new HttpHeaders({
        'Authorization': 'Bearer 55d6895dgdc74efdbcb42f654f7e9d10'
      });
      const options = {
        headers: header
      }  
      let url = this.config.get('product').videoFeedUrl + '?limit=50&sortby=updated_at&Orderby=-1';
      if (this.filterUrl) {
        for (const filter in this.filterUrl) {
          if (filter) {
            url += this.filterUrl[filter];
          }
        }
      }
      if (url.indexOf('sitename') === -1) {
        url += '&sitename=' + this.videoFeedDomains;
      }
      this.http.get(url, options).subscribe(
        (response) => {
          this.videoList = [];
          this.multiList = [];
          this.videoList = response['response'];
          this.multiList = this.createMultipleList(this.videoList);
          this.totalRecords = response['total_records'];
          this.pages = Math.ceil(this.totalRecords / 50);
          this.callFail = false;
        },
        (error) => {
          console.log(error);
          this.callFail = false;
        }
      );
    } 
    else {
      if (this.config.getEndPoint(this.config.get('views'), this.page_id, this.api) !== 'false') {
        this.page_id === 'pixabayListing' ? pageNum = pageNum +1: pageNum;
        let url = this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.api) + '?page=' + pageNum + '&size=';
        if (url && url.indexOf('wires/images') !== -1) {
          url += '10';
        } else {
          url += this.byField === 'image' ? '10' : this.pageSize;
        }
        if (this.sortByValueOf && this.page_id !== 'mobile91Listing' && this.page_id !== 'pixabayListing') {
          url += '&sort=' + this.sortByValueOf + ',desc';
        }
        url += '&search=';
        if (this.byField) {
          url += 'type:' + this.byField;
        }
        if (this.byAgencyWire) {
          if (this.byAgencyWire === 'notmint_print') {
            url += ',agency!mint_print,agency!digital_ht' + this.agencyHide;
          } else {
            if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['jsonfeed']
              && this.domainConfig['config']['jsonfeed']['print_feed']) {
              url += ',agency:' + this.domainConfig['config']['jsonfeed']['print_feed'];
            } else {
              url += ',agency:' + this.byAgencyWire;
            }
          }
        }
        if (this.bySourceWire) {
          if (this.bySourceWire.indexOf('not') !== -1) {
            const val = this.bySourceWire.split('_')[1];
            url += ',source!' + val;
          } else {
            url += ',source:' + this.bySourceWire;
          }
        }
        if (this.isPickEnabled) {
          if (this.typesToPick && this.typesToPick.trim() !== '') {
            //const types = this.typesToPick.trim().split(',').join(';');
            url += ',type:' + this.typesToPick + ',reusable:true';
          } else {
            url += ',type:embed;table,reusable:true';
          }
        }
        if (this.byElemets && !this.filterUrl['type']) {
          url += 'type:collection;embed;jsonfeed;toptrends;banner;communities;placeholder,reusable:true';
        }
        if ((this.RelatedStorySearch || this.isPickEnabled) && !this.typesToPick) {
          url += ',metadata.status:PUBLISHED';
          if(this.relatedStoryType=='gallery' || this.relatedStoryType=='video' || this.relatedStoryType=='web-story') 
          {
            this.filterUrl=",type:"+this.relatedStoryType;}
          if(this.relatedStoryType=='howto') 
          {
            
            this.filterUrl =",metadata.section:"+this.defaultRelatedStoryHowToFilter;}
        }
        if (this.by_Author) {
          url += ',readByUsers:' + this.by_Author;
        }
        if (this.page_id === 'slidePhotoListing') {
          url += ',hasSlideImage:true';
          url += ',parentElementId:0';
        }
        if (this.page_id === 'slideVideoListing') {
          url += ',hasSlideVideo:true';
        }
        if (this.page_id === 'photoListing') {
          url += ',parentElementId:0';
        }
        if (this.page_id === 'affiliatePhotoListing') {
          url += ',parentElementId:0';
        }
        if(this.domainWiseImageList) {
          url += ',domainId' 
                    + (this.domainWiseImageList === 'all' ? '!' + sessionStorage.getItem(StaticDataService.domainLiteral) : ':' + this.domainWiseImageList);
        }
        if (this.filterUrl) {
          for (const filter in this.filterUrl) {
            if (filter) {
              url += this.filterUrl[filter];
            }
          }
          if (this.byElemets) {
            url += ',reusable:true';
          }
        }
        if (this.page_id === 'pages' || this.page_id === 'element' || this.page_id === 'all_stories' || this.page_id === 'my_workspace') {
          url += '&fields=reusable,metadata.markUnimportant,metadata.killed,metadata.tags,metadata.breakingNews,metadata.sponsored,lockedByUserId,id,status,lockedByUserName,imageAmpValidated,metadata.status,articleType,elements,metadata.url,' + this.fields;
        }
        if (this.page_id === 'videoServiceStory') {
          url = url + ',type:video';
        }
        this.callFail = false;
        if (this.initialUrl === '') {
          this.initialUrl = url;
        }
        this.latestUrl = url;

    this.timings['firstGet'] = performance.now();
    if(this.page_id !== 'wirephotoListing' && this.page_id !== 'pixabayListing' && this.page_id !== 'mobile91Listing' &&(!this.filterUrl || Object.keys(this.filterUrl).length === 0) && this.domainConfig 
      && this.domainConfig['config'] && this.domainConfig['config']['image'] 
      && this.domainConfig['config']['image']['daysRange']) 
    {
      console.log(this.page_id)
      const days = this.domainConfig['config']['image']['daysRange'];
      const todayStart = new Date().getTime()
      const offset = (24*60*60*1000) * days;
      const offsetDate = todayStart - offset;
      url += ",createdDate%3E" + offsetDate + ",createdDate%3C" + todayStart;
    }
   // console.log('firstGet => ', performance.now() - this.timings.constr);
        this.restService.http_get(url)
          .subscribe(data => {
            this.timings['resp'] = performance.now();
   // console.log('response => ', performance.now() - this.timings['firstGet']);
            this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
            this.totalRecords = data['totalElements'];
            this.callFail = false;
            this.topFunction();
            this.measureTime(0);
            callback(data);
          });
      } else {
        console.log("in else block..");
        this.callFail = true;
        // console.log('url not found');
      }
    }
  }

  getautoSuggestion(query, search_api, callback) {
    if (this.config.getEndPoint(this.config.get('views'), this.page_id, search_api) !== 'false' && this.page_id!='all_related_stories_embed' ) {
      if (search_api && query) {
        const tempQuery = query;
        this.str = tempQuery;
        query = query.split(' ');
        query = query[(query.length - 1)];
        if (query && query.length > 2 && this.valueChangeEvent) {
          this.showSuggestionBox = false;
          const url = this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), this.page_id, search_api)
            + '?text=' + StaticDataService.encodeSpecialChar(tempQuery);
          this.restService.http_get(url)
            .subscribe(data => {
              callback(data);
            },
              error => {
                // console.log(error);
              });
        }
      } else {
        if(this.page_id!='all_related_stories_embed'){
          this.getDefaultList(0, data1 => {
            if (data1 && data1['content'] && data1['content'].length > 0) {
              this.listArray = [];
              this.listIdArray = [];
              this.multiList = [];
              this.dataInsertion(data1['content']);
              if (this.page_id === 'videoServiceStory') {
                this.multiList = this.createMultipleList(this.listArray);
              }
              this.noresults = false;
            } else {
              this.noresults = true;
            }
          });
        }
       
        this.showSuggestionBox = false;
      }
    } else {
      console.log("CLG not being called")
    }
  }
  getsearchResults(item) {
    // this.getImageSuggestions
    this.searchResults(item, 0, data => {
      this.pageNum = 0;
      this.listArray = [];
      this.listIdArray = [];
      this.multiList = [];
      if (data &&  data['content'] && data['content'].length > 0) {
        this.dataInsertion(data['content']);
        if (this.page_id === 'videoServiceStory') {
          this.multiList = this.createMultipleList(this.listArray);
        }
        this.noresults = false;
        this.showSuggestionBox = false;
        this.valueChangeEvent = false;
        // this.str = item;
      } else {
        this.noresults = true;
        this.showSuggestionBox = true;
        this.valueChangeEvent = true;
      }
    });
  }
  onKeydownEmbed(event) {
    if (event.key === 'Enter') {
      this.pageNum=0;
      this.getsearchResults(this.str);
      this.showSuggestionBox = false;
    } 
    
    return true;
  }
  getSuggestedImages(str) {
    if(this.str.length > 0) {
      this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/image/imageSuggestions?text='+this.str)
      .subscribe(data => {
        this.suggestedItems = data;
      });
    }
  }
  onKeydown(event) {
    if (event.key === 'Enter') {
      if(this.page_id === 'podcast') {
        this.searchEpisodesByKeyWords(this.str);
      } else {
        this.getsearchResults(this.str);
        this.suggestedItems = [];
        this.getSuggestedImages(this.str)
        this.showSuggestionBox = false;
      }
    } else if (event.keyCode === 32) {
      // console.log(this.str + '\'');
      this.getautoSuggestion(this.str, this.suggestion_api, data => {
        this.listSuggestionArray = [];
        const dataSuggestion = data;
        if (dataSuggestion && dataSuggestion.length > 0) {
          for (let i = 0; i < dataSuggestion.length; i++) {
            this.listSuggestionArray.push(dataSuggestion[i]);
          }
          this.showSuggestionBox = true;
        } else {
          this.showSuggestionBox = false;
        }
      });
    } else if (event.keyCode === 40 && this.arrowkeyLocation < this.listSuggestionArray.length - 1) {
      this.valueChangeEvent = false;
      this.showSuggestionBox = true;
      this.arrowkeyLocation++;
      this.str = this.listSuggestionArray[this.arrowkeyLocation];
      // console.log(this.searchInput);
    } else if (event.keyCode === 38 && this.arrowkeyLocation > 0) {
      this.valueChangeEvent = false;
      this.showSuggestionBox = true;
      this.arrowkeyLocation--;
      this.str = this.listSuggestionArray[this.arrowkeyLocation];
      // console.log(this.searchInput);
    } else {
      this.valueChangeEvent = true;
      this.arrowkeyLocation = 0;
    }
    return true;
  }

  searchResults(query1, pageNum, callback) {
    this.amzonEmbedList=[]
    const query = query1;
    if (this.page_id === 'videoStory') {
      this.isVideoStory = true;
      const header = new HttpHeaders({
        'Authorization': 'Bearer 55d6895dgdc74efdbcb42f654f7e9d10'
      });
      const options = {
        headers: header
      }  
      const offset = pageNum === 0 ? 0 : (this.pageSize * pageNum);
      let url = this.config.get('product').videoFeedUrl + '?limit=' + this.pageSize + '&sortby=updated_at&Orderby=-1';
      if (this.filterUrl) {
        for (const filter in this.filterUrl) {
          if (filter) {
            url += this.filterUrl[filter];
          }
        }
      }
      if (url.indexOf('sitename') === -1) {
        url += '&sitename=' + this.videoFeedDomains;
      }
      if (query1) {
        url += '&q=' + query1;
      }
      url += '&from=' + offset;
      this.http.get(url, options).subscribe(
        (response) => {
          this.videoList = [];
          this.multiList = [];
          this.videoList = response['response'];
          this.multiList = this.createMultipleList(this.videoList);
          this.totalRecords = response['total_records'];
          this.pages = Math.ceil(this.totalRecords / this.pageSize);
          this.topFunction();
          // this.callFail = false;
          if (this.multiList && this.multiList.length > 0) {
            this.noresults = false;
          } else {
            this.noresults = true;
          }
        },
        (error) => {
          console.log(error);
          this.callFail = true;
        }
      );
    } 
    else if(this.page_id==='all_related_stories_embed'){
      this.callFail=true;
      if(this.amazonOrSnapdeal === 'amazon') {
        if (this.config.getEndPoint(this.config.get('views'), this.page_id, this.search_api) !== 'false') {
          if (this.search_api && query1) {
            let url = this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), this.page_id, this.search_api) + '?keywords=';
              if(url){
                url += query1+ '&pageNo='+(pageNum+1) +'&pageSize='+10 ;
                this.restService.http_get(url)
                .subscribe(data => {
  
                  if( data.itemsList !=null){
                    let lenofPages:number=+data.itemsList.length;
                    let lenOfTotalResult:number=100;
                    this.amzonEmbedList.push(data);
                    for(let i=0;i< this.amzonEmbedList[0]['itemsList'].length;i++){
                      this.amzonEmbedList[0]['itemsList'][i]['checked']=false;
                    }
                     if(this.selectedItemAmazonList && this.selectedItemAmazonList.length !=0){
                       for(let i=0;i<this.amzonEmbedList[0]['itemsList'].length;i++){
                        for(let j=0;j<this.selectedItemAmazonList.length;j++){
                           if(this.amzonEmbedList[0]['itemsList'][i]['itemId']==this.selectedItemAmazonList[j]['itemId']){
                            this.amzonEmbedList[0]['itemsList'][i]['checked']=true;
                           }
                        }
                       }
                     }
                    this.pageSize = data.itemsList.length;
                    this.totalRecords = 100;
                    this.pages=  Math.floor(lenOfTotalResult/lenofPages);
  
                   
                    // this.topFunction();
                     this.callFail = false;
                     this.snotify.success('Fetched New Records!');
                  }
                  else{
                    this.snotify.error('No Record Found!', '', this.sharedService.getConfig(false))
                    this.callFail = false;
                  }
                  
                  // callback(data);
                },
                  error => {
                    if(error.error.staus==404){
  
                      this.callFail = false;
                      this.snotify.error(JSON.stringify(error.error.error), '', this.sharedService.getConfig(false))
                      // console.log(error);
                    }else{
                      this.callFail = false;
                      this.snotify.error('Something went wrong!', '', this.sharedService.getConfig(false))
                    }
                  });
              }
          }
        }
      } else if(this.amazonOrSnapdeal === 'snapdeal'){
        let url = this.config.get('product').seoUrl
              + "/api/cms/affiliate/getItems/";
        if(url){
          url += query1;
          console.log(url)
          this.restService.http_get(url)
          .subscribe(data => {
            console.log(data)
            if(this.snapdealEmbedList && this.snapdealEmbedList.length > 0) {
            this.snotify.success('Fetched New Records!', '', this.sharedService.getConfig(false));
            }
            this.callFail = false;
            this.snapdealEmbedList = data;
            if(this.snapdealEmbedList && this.snapdealEmbedList.length < 1) {
              this.emptyList = true;
              this.snotify.error('No Record Found!', '', this.sharedService.getConfig(false))
            }
          });
        }

        for(let i=0;i< this.snapdealEmbedList.length;i++){
          this.snapdealEmbedList[i]['checked']=false;
        }
        if(this.selectedItemSnapdealList && this.selectedItemSnapdealList.length !=0){
          for(let i=0;i<this.snapdealEmbedList.length;i++){
           for(let j=0;j<this.snapdealEmbedList.length;j++){
              if(this.snapdealEmbedList[i]['itemId']==this.snapdealEmbedList[j]['itemId']){
               this.snapdealEmbedList[i]['checked']=true;
              }
           }
          }
        }
        console.log(this.snapdealEmbedList);
        // if (this.config.getEndPoint(this.config.get('views'), this.page_id, this.search_api) !== 'false') {
        //   if (this.search_api && query1) {
            // let url = this.config.get('product').baseUrl
            //   + this.config.getEndPoint(this.config.get('views'), this.page_id, this.search_api) + '?keywords=';
              // if(url){
              //   url += query1+ '&pageNo='+(pageNum+1) +'&pageSize='+10 ;
              //   this.restService.http_get(url)
              //   .subscribe(data => {
  
              //     if( data.itemsList !=null){
              //       let lenofPages:number=+data.itemsList.length;
              //       let lenOfTotalResult:number=100;
              //       this.amzonEmbedList.push(data);
              //       for(let i=0;i< this.amzonEmbedList[0]['itemsList'].length;i++){
              //         this.amzonEmbedList[0]['itemsList'][i]['checked']=false;
              //       }
              //        if(this.selectedItemAmazonList.length !=0){
              //          for(let i=0;i<this.amzonEmbedList[0]['itemsList'].length;i++){
              //           for(let j=0;j<this.selectedItemAmazonList.length;j++){
              //              if(this.amzonEmbedList[0]['itemsList'][i]['itemId']==this.selectedItemAmazonList[j]['itemId']){
              //               this.amzonEmbedList[0]['itemsList'][i]['checked']=true;
              //              }
              //           }
              //          }
              //        }
              //       this.pageSize = data.itemsList.length;
              //       this.totalRecords = 100;
              //       this.pages=  Math.floor(lenOfTotalResult/lenofPages);
  
                   
              //       // this.topFunction();
              //        this.callFail = false;
              //        this.snotify.success('Fetched New Records!');
              //     }
              //     else{
              //       this.snotify.error('No Record Found!', '', this.sharedService.getConfig(false))
              //       this.callFail = false;
              //     }
                  
              //     // callback(data);
              //   },
              //     error => {
              //       if(error.error.staus==404){
  
              //         this.callFail = false;
              //         this.snotify.error(JSON.stringify(error.error.error), '', this.sharedService.getConfig(false))
              //         // console.log(error);
              //       }else{
              //         this.callFail = false;
              //         this.snotify.error('Something went wrong!', '', this.sharedService.getConfig(false))
              //       }
              //     });
              // }
        //   }
        // }


      }
      else if(this.isCroma && this.isCroma=== true)
      {
        let url = this.config.get('product').seoUrl
              + "/api/cms/affiliate/croma/getItems/";
        if(url){
          url += query1;
          this.restService.http_get(url)
          .subscribe(data => {
            console.log(data);
            this.cromaEmbedList = data;
            if(this.cromaEmbedList.length > 0) {
              this.emptyList = false;
            this.snotify.success('Fetched New Records!', '', this.sharedService.getConfig(false));
            }
            this.callFail = false;
            if(this.cromaEmbedList.length < 1) {
              this.emptyList = true;
              this.snotify.error('No Record Found!', '', this.sharedService.getConfig(false));
            }
          },
          error=>{
            this.callFail = false;
            this.emptyList = true;
            this.cromaEmbedList = [];
            this.snotify.error('No Record Found!', '', this.sharedService.getConfig(false));
          });
        }

        for(let i=0;i< this.cromaEmbedList.length;i++){
          this.cromaEmbedList[i]['checked']=false;
        }
        if(this.selectedItemCromaList.length !=0){
          for(let i=0;i<this.cromaEmbedList.length;i++){
           for(let j=0;j<this.cromaEmbedList.length;j++){
              if(this.cromaEmbedList[i]['itemId']==this.cromaEmbedList[j]['itemId']){
               this.cromaEmbedList[i]['checked']=true;
              }
           }
          }
        }
      }  else if(this.amazonOrSnapdeal === 'affiliate') {
        let url = this.config.get('product').seoUrl
              + "/api/cms/affiliate/amazon/getItems";
        if(url){
          url += "?keyword="+query1;
          if(this.ref)
          {
            url += "&ref="+this.ref;
          }
          this.restService.http_get(url)
          .subscribe(data => {
            console.log(data);
            this.affiliateEmbedList = data.items;
            if(this.affiliateEmbedList.length > 0) {
              this.emptyList = false;
              this.snotify.success('Fetched New Records!', '', this.sharedService.getConfig(false));
            }
            this.callFail = false;
            if(this.affiliateEmbedList.length < 1) {
              this.emptyList = true;
              this.snotify.error('No Record Found!', '', this.sharedService.getConfig(false));
            }
          },
          error=>{
            this.callFail = false;
            this.emptyList = true;
            this.affiliateEmbedList = [];
            this.snotify.error('No Record Found!', '', this.sharedService.getConfig(false));
          });
        }

        for(let i=0;i< this.affiliateEmbedList.length;i++){
          this.affiliateEmbedList[i]['checked']=false;
        }
      }
      
      return;
    }
    
    
    else {
      if (this.config.getEndPoint(this.config.get('views'), this.page_id, this.search_api) !== 'false') {
        if (this.search_api && query1) {
          this.page_id === 'pixabayListing' ? pageNum = pageNum +1: pageNum;

          let url = this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), this.page_id, this.search_api) + '?page=' + pageNum + '&size=';
           
          if (url && url.indexOf('wires/images') !== -1) {
            url += '10';
          } else {
            url += this.byField === 'image' ? '10' : this.pageSize;
          }
          if (this.sortByValueOf && this.page_id !== 'mobile91Listing' && this.page_id !== 'pixabayListing') {
            url += '&sort=' + this.sortByValueOf + ',desc';
          }
          if (this.exactMatch) {
            url += '&exact=true';
          }
          url += '&search=';
          if (this.byField) {
            url += 'type:' + this.byField;
          }
          if (this.by_Author) {
            url += ',readByUsers:' + this.by_Author;
          }
          if ((this.RelatedStorySearch || this.isPickEnabled) && !this.typesToPick) {
            url += ',metadata.status:PUBLISHED';
          }
          if (this.byAgencyWire) {
            if (this.byAgencyWire === 'notmint_print') {
              url += ',agency!mint_print';
            } else {
              url += ',agency:' + this.byAgencyWire;
            }
          }
          if (this.isPickEnabled) {
            if (this.typesToPick && this.typesToPick.trim() !== '') {
              const types = this.typesToPick.trim().split(',').join(';');
              url += ',type:' + types + ',reusable:true';
            } else {
              url += ',type:embed;table,reusable:true';
            }
          }
          if (this.bySourceWire) {
            if (this.bySourceWire.indexOf('not') !== -1) {
              const val = this.bySourceWire.split('_')[1];
              url += ',source!' + val;
            } else {
              url += ',source:' + this.bySourceWire;
            }
          }
          if (this.page_id === 'photoListing') {
            url += ',parentElementId:0';
          }
          if (this.page_id === 'affiliatePhotoListing') {
            url += ',parentElementId:0';
          }
          if(this.domainWiseImageList) {
            url += ',domainId' 
                      + (this.domainWiseImageList === 'all' ? '!' + sessionStorage.getItem(StaticDataService.domainLiteral) : ':' + this.domainWiseImageList);
          }
          if (this.filterUrl) {
            for (const filter in this.filterUrl) {
              if (filter) {
                url += this.filterUrl[filter];
              }
            }
          }
          if (query && query.trim() !== '') {
            const querArr = query.split(':');
            let conti = true;
            if (querArr && querArr.length > 0) {
              if (querArr[0].toUpperCase() === 'ID') {
                url += ',id:' + querArr[1].trim();
                conti = false;
              }
            }
            if (conti && this.page_id === 'pages') {
              url += ',name~' + StaticDataService.encodeSpecialChar(query);
            } else if (conti && this.page_id === 'element') {
              url += ',title~' + StaticDataService.encodeSpecialChar(query);
            } else if (conti) {
              url +=  this.page_id === 'pixabayListing'? StaticDataService.encodeSpecialChar(query):',text~' + StaticDataService.encodeSpecialChar(query)
            }
          }
          if (this.byElemets && !this.filterUrl['type']) {
            url += ',type:collection;embed;jsonfeed;toptrends;banner;communities;placeholder,reusable:true';
          }
          if (this.page_id === 'videoServiceStory') {
            url = url + ',type:video';
          }
          this.callFail = false;
          if (this.page_id === 'pages' || this.page_id === 'element' || this.page_id === 'all_stories' || this.page_id === 'my_workspace') {
            url += '&fields=reusable,metadata.markUnimportant,metadata.killed,metadata.tags,metadata.breakingNews,metadata.sponsored,id,lockedByUserId,status,lockedByUserName,imageAmpValidated,metadata.status,articleType,elements,metadata.url,' + this.fields;
          }
          this.latestUrl = url;
          this.restService.http_get(url)
            .subscribe(data => {
              this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
              this.totalRecords = data['totalElements'];
              this.topFunction();
              this.callFail = false;
              callback(data);
            },
              error => {
                this.callFail = true;
                // console.log(error);
              });
        } else {
          this.getDefaultList(pageNum, data => {
            callback(data);

          });
        }
      } else {
        // console.log('url not found');
      }
    }
  }

  urlUpdate(ev) {
    this.filterUrl[ev.type] = ev.data;
    this.pageNum = 0;
    this.searchResults(this.searchQuery.value, this.pageNum, data => {
      this.listArray = [];
      this.listIdArray = [];
      this.multiList = [];
      if (data && data['content'] && data['content'].length > 0) {
        this.dataInsertion(data['content']);
        if (this.page_id === 'videoServiceStory') {
          this.multiList = this.createMultipleList(this.listArray);
        }
        this.noresults = false;
      } else {
        this.noresults = true;
      }
    });
  }

  selectStoryId(ev, type) {
    const index = this.relatedStoryArray.indexOf(ev.id);
    const listindex = this.relatedSelectedArray.findIndex(item => item.id === ev.id);
    if (this.multipleStories) {
      if (index < 0) {
        this.relatedStoryArray.push(ev.id);
        this.relatedSelectedArray.push(ev);
        const newId = this.listArray.findIndex(item => item.id === ev.id);
        this.listArray.splice(newId, 1);
      } else {
        this.relatedStoryArray.splice(index, 1);
        const item = this.relatedSelectedArray[listindex];
        this.relatedSelectedArray.splice(listindex, 1);
        this.listArray.unshift(item);
      }
      if(this.relatedStoryType=='web-story')
      {
        this.sendRelatedStoryGalleryType.emit({
          data: this.relatedSelectedArray,
          type: 'multiple'
        });
      }
      this.sendIdToParentfn.emit({
        id: this.relatedSelectedArray.map(a => a.id),
        type: 'multiple'
      });
    } else {
      if(this.relatedStoryType=='gallery' || this.relatedStoryType=='video' || this.relatedStoryType=='web-story'){
       console.log('relatedStoryData',ev)
       this.sendRelatedStoryGalleryType.emit(ev)
      }else{
        this.sendIdToParentfn.emit({
          id: ev.id,
          obj: ev,
          type: 'single'
        });
      }
      
    }
  }
  selectAmazonEmbed(ev, type) {
    this.selectedAmazonItemList(ev)
     this.sendIdToParentfn.emit(
       {data:ev,
        type:'multiple'
      }
       );
}

selectAffiliateEmbed(ev) {
  this.selectedAffiliateItemList(ev)
   this.sendIdToParentfn.emit(
     {data:ev,
      type:'singleSelectDone'
    }
     );
}
  selectSnapdealEmbed(ev, type) {
    this.selectedSnapdealItemList(ev)
    this.sendIdToParentfn.emit(
      {data:ev,
        type:'multiple'
      }
      );
  }
  selectedAmazonItemList(ev) {
    if(this.selectedItemAmazonList && this.selectedItemAmazonList.length==0){
      this.selectedItemAmazonList.push(ev);
    } else {
      const removeIndex = this.selectedItemAmazonList.findIndex(item => item.itemId === ev.itemId);
      if (removeIndex == -1) {
        this.selectedItemAmazonList.push(ev);
      } else {
        this.selectedItemAmazonList.splice(removeIndex, 1);
      }
    }
  }

  selectedAffiliateItemList(ev) {
    if(this.selectedItemAffiliateList && this.selectedItemAffiliateList.length==0){
      this.selectedItemAffiliateList.push(ev);
    } else {
      const removeIndex = this.selectedItemAffiliateList.findIndex(item => item.itemId === ev.itemId);
      if (removeIndex == -1) {
        this.selectedItemAffiliateList.push(ev);
      } else {
        this.selectedItemAffiliateList.splice(removeIndex, 1);
      }
    }
  }

  selectCromaEmbed(ev,type){
    this.selectedCromaItemList(ev);
    this.sendIdToParentfn.emit({
      data:ev,
      type:'multiple'
    });
  }
  selectedSnapdealItemList(ev) {
    if(this.selectedItemSnapdealList && this.selectedItemSnapdealList.length==0){
      this.selectedItemSnapdealList.push(ev);
    } else {
      const removeIndex = this.selectedItemSnapdealList.findIndex(item => item.itemId === ev.itemId);
      if (removeIndex == -1) {
        this.selectedItemSnapdealList.push(ev);
      } else {
        this.selectedItemSnapdealList.splice(removeIndex, 1);
      }
    }
  }

  selectedCromaItemList(ev) {
    if(this.selectedItemCromaList.length==0){
      this.selectedItemCromaList.push(ev);
    } else {
      const removeIndex = this.selectedItemCromaList.findIndex(item => item.itemId === ev.itemId);
      if (removeIndex == -1) {
        this.selectedItemCromaList.push(ev);
      } else {
        this.selectedItemCromaList.splice(removeIndex, 1);
      }
    }
  }

  getSelectedItem(itemId:string) {
    this.selectedItemAmazonList.some((o)=>{
         return this.checked=  o.itemId==itemId;
   })
  
  }
  topFunction() {
    this.currentRowSelected = 1;
    document.body.scrollTop = 0; // For Safari
    if (document.getElementsByClassName('contentList') && document.getElementsByClassName('contentList').length > 0) {
      document.getElementsByClassName('contentList')[0].scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    if (this.page_id === 'videoStory' || (this.page_id === 'videoServiceStory' && this.selectedItem === 'gridView')) {
      if (document.getElementsByClassName('videoslistBlock') && document.getElementsByClassName('videoslistBlock').length > 0) {
        document.getElementsByClassName('videoslistBlock')[0].scrollTop = 0;
      }

    }
  }

  sendImageToParent(image, type) {
    
    if (type === 'wire') {
      this.sendIdToParentfn.emit({
        id: this.wireImageUrl + image.location + '/' + image.fileName,
        data: image,
        type: 'wire'
      });
    } else if(type === 'mobile91') {
      this.sendIdToParentfn.emit({
        id: this.mobile91DisplayUrl + image.url,
        data: image,
        type: 'wire'
      });
    } else if(type === 'crossTenant') {
      this.sendIdToParentfn.emit({
        id: image.image.images['original'],
        data: image.image,
        type: 'wire'
      });
    } else if(type=== 'pixabay'){
      this.sendIdToParentfn.emit({
        id: image.largeImageURL,
        data: image,
        type: 'wire'
      });
    } else {
      this.sendIdToParentfn.emit({
        id: image.id,
        type: image.type,
        data: image
      });
    }
  }
  sendVideoToParent(video) {
    this.sendIdVieoToParentfn.emit(video);
  }

  sendPodcastToParent(podcast) {
    if(this.insideSearchByKeyWord) {
      podcast['publisherId'] = podcast.podcast_id
      podcast['publisherName'] = podcast.podcast_title;
      console.log('=== > podcast :: ', podcast);
    } else {
      podcast['publisherId'] = this.selectedPodcastPublisher.id;
      podcast['publisherName'] = this.selectedPodcastPublisher.name;
      console.log('--- > podcast :: ', podcast);
    }
    this.sendPodcastToParentfn.emit(podcast);
    
  }

  downloadImage(url) {
    const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + url;
    this.sharedService.getImage(imageUrl).subscribe(e => {
      const reader = new FileReader();
      const fd = new FormData();
      const a = reader.readAsDataURL(e);
      const urlName = imageUrl.split('/original/');
      const extUrlType = (urlName.length > 1) ? urlName[1] : urlName[0];
      reader.onload = (e4: any) => {
        const blobD = this.convertBase64ToBlob(e4.target.result);
        if (window.navigator && window.navigator['msSaveOrOpenBlob']) { // IE
          window.navigator['msSaveOrOpenBlob'](blobD, 'Qrcode');
        } else { // chrome
          const blob = new Blob([blobD], { type: 'image/' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = extUrlType;
          link.click();
        }
      };
    },
      err => {
        console.log(err);
      });
  }

  private convertBase64ToBlob(Base64Image: any) {
    // SPLIT INTO TWO PARTS
    const parts = Base64Image.split(';base64,');
    // HOLD THE CONTENT TYPE
    const imageType = parts[0].split(':')[1];
    // DECODE BASE64 STRING
    const decodedData = window.atob(parts[1]);
    // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
    const uInt8Array = new Uint8Array(decodedData.length);
    // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // RETURN BLOB IMAGE AFTER CONVERSION
    return new Blob([uInt8Array], { type: 'image/' });
  }

  closest(el, selector) {
    let matchesFn;
    ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
      if (typeof document.body[fn] === 'function') {
        matchesFn = fn;
        return true;
      }
      return false;
    });
    let parent;
    while (el) {
      parent = el.parentElement;
      if (parent && parent[matchesFn](selector)) {
        return parent;
      }
      el = parent;
    }

    return null;
  }

  pusharrayImage(image2, type) {
    const image = Object.assign({}, image2);
    const id2 = image2.id ? image2.id : null;
    var el = this.closest(document.getElementById(image.id), '.imageblock');
    if (el && el.classList) {
      el.classList.toggle('selected');
    }

    const index = this.listImageArrayC.findIndex(item => item.id2 === id2);

    if (index < 0) {
      if (type === 'wire') {
        const imageUrl = this.wireImageUrl + image.location + '/' + image.fileName;
        image['id'] = imageUrl;
        this.listImageArrayC.push({ id2: id2, id: image.id, imgtype: type, imageUrl: imageUrl, data: image });
      } else if(this.domainWiseImageList) {
        this.listImageArrayC.push(
            { id2: id2, id: image['image']['images']['original'], imgtype: 'wire', imageUrl: image['image']['images']['original'], data: image.image }
          );
      } else if(type === 'mobile91') {
        console.log("MOBILE")
        const imageUrl = this.mobile91DisplayUrl + image.url;
        image['id'] = imageUrl;
        this.listImageArrayC.push({ id2: id2, id: image.id, imgtype: 'wire', imageUrl: imageUrl, data: image });
      } else if(type === 'pixabay'){
        const imageUrl = image.largeImageURL;
        image['id'] = imageUrl;
        this.listImageArrayC.push({ id2: id2, id: image.id, imgtype: 'wire', imageUrl: imageUrl, data: image });
      } else {
        this.listImageArrayC.push({ id2: id2, id: image.id, imgtype: type, imageUrl: image['image']['images']['original'] });
      }
    } else {
      this.listImageArrayC.splice(index, 1);
    }
    this.sendListIdToParentfn.emit(this.listImageArrayC);

    if (type !== 'wire') {
      // $('#p_' + image.id).closest('.list').toggleClass('selected');
      let el = this.closest(document.getElementById('p_' + image.id), '.list');
      if (el && el.classList) {
        el.classList.toggle('selected');
      }
    }
  }

  getValuefromObject(o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    const a = s.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (k in o) {
        if (o[k] !== null) {
          o = o[k];
        } else {
          return '-';
        }
      } else {
        return '-';
      }
    }
    if (((typeof o) === 'number') && o !== 0) {
      return o;
    } else if (o && ((typeof o) === 'string') && o.trim() !== '') {
      return o;
    } else {
      return '-';
    }
  }

  getFilterData(facet_name) {
    if (this.facets && this.facets[facet_name]) {
      return this.facets[facet_name];
    } else {
      return null;
    }
  }

  getFullDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + ' ' + date.getFullYear() + ', ' +
        ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours()) + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes());
    } else {
      return 'not present';
    }
  }

  getFullDateDay(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate();
    } else {
      return 'not present';
    }
  }

  getNewTypeDate(datestring) {
    if (datestring) {
      if (typeof datestring === 'string') {
        const dt = new Date(datestring.replace('+0000', 'Z'));
        return this.getFullDate(Math.round(dt.getTime()));
      } else {
        return this.getFullDate(datestring);
      }
    } else {
      return 'not present';
    }
  }

  getNewTypeDateDay(datestring) {
    if (datestring) {
      if (typeof datestring === 'string') {
        const dt = new Date(datestring.replace('+0000', 'Z'));
        return this.getFullDateDay(Math.round(dt.getTime()));
      } else {
        return this.getFullDateDay(datestring);
      }
    } else {
      return 'not present';
    }
  }
  getfilterDate(date) {
    return date.year
      + '' + (((date.month + 1) < 10) ? '0' + (date.month + 1) : (date.month + 1))
      + '' + (((date.day + 1) < 10) ? '0' + (date.day + 1) : (date.day + 1));
  }

  htmlToPlaintext(text) {
    if (typeof text === 'string') {
      return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    } else {
      return text;
    }
  }

  htmlToPlaintextlisting(text) {
    if (typeof text === 'string') {
      return text ? String(text).replace(new RegExp('<em>', 'g'), '~@em@~').replace(new RegExp('</em>', 'g'), '~@/em@~')
        .replace(/<[^>]+>/gm, '')
        .replace(new RegExp('~@em@~', 'g'), '<em>').replace(new RegExp('~@/em@~', 'g'), '</em>').trim() : '';
    } else {
      return text;
    }
  }

  trackByName(index, instructor) {
    return instructor;
  }
  showimagePreview(photoId, views) {
    if (views) {
      this.lightBoxP = photoId;
    } else {
      this.lightBoxP = null;
    }
    this.viewPhoto = views;
  }
  unselectAll() {
    this.ImageArray = [];
    this.listImageArrayC = [];
    $('.image').closest('.imageblock').removeClass('selected');
    let el1 = this.closest(document.getElementsByClassName('image'), '.imageblock');
    if (el1 && el1.classList) {
      el1.classList.remove('selected');
    }
    for (let i = 0; i < document.getElementsByClassName('list').length; i++) {
      if (document.getElementsByClassName('list')[i] && document.getElementsByClassName('list')[i].classList) {
        document.getElementsByClassName('list')[i].classList.remove('selected');
      }
    }
    this.sendToClearImageList.emit(true);
  }
  pushImageList() {
    console.log(this.listImageArrayC)
    this.sendIdToParentfn.emit(this.listImageArrayC);
    this.sharedService.overflowauto();
    this.unselectAll();

  }
  getclassonCondition(lockStatus, storyStatus) {
    let ulClass = null;
    if (lockStatus && storyStatus === 'PUBLISHED') {
      ulClass = 'publishlockedIcon';
    } else if (lockStatus) {
      ulClass = 'lockedIcon icon-lock';
    } else if (storyStatus === 'PUBLISHED') {
      ulClass = 'publishIcon icon-published';
    }
    return ulClass;
  }
  updateCopyCounter(item) {
    const dataObj = item;
    dataObj.copyCounter += 1;
    this.restService.http_put(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, 'save_wire')
      + '/' + dataObj.id,
      dataObj,
      res => {

      });
  }

  openPreview(item) {
    this.snowplowAnalytics(('/dash/story/new?refId=' + item.id), 'preview story');
    this.openWirePreview = true;
    item.story[0].content = this.sanitizer.bypassSecurityTrustHtml(item.story[0].content);
    this.wirePreviewStory = item;
    this.sharedService.overflowhidden();

  }

  closePreview() {
    this.openWirePreview = false;
    this.wirePreviewStory = null;
    this.translatedPreviewStory = null;
    this.compareStory = false;
    this.sharedService.overflowauto();
  }

  open_new(id) {
    window.open(window.location.origin + '/dash/story/' + id, '_blank');
  }

  async mapStoryObject(dataObj, callback) {
    let paraContent = '';
    const story = JSON.parse(JSON.stringify(StaticDataService.defaultStoryData));

    // this.translateStoryAsyn(contentData).subscribe(dataObj => {
    if (dataObj) {
      if (dataObj.story && dataObj.story !== null && dataObj.story.length > 0) {
        paraContent = dataObj.story[0]['content'] ? dataObj.story[0]['content'] : null;
        story.summary = dataObj.story[0].summary ? dataObj.story[0].summary.trim() : '';
        story.metadata.authors = dataObj.story[0].author ? (dataObj.story[0].author as string).split(',') : null;
      } else {
        paraContent = null;
        story.summary = '';
        story.metadata.authors = null;
      }
      story.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      story.wireFeedId = dataObj.id ? dataObj.id : null;
      story.mobileHeadline = dataObj.headline ? dataObj.headline : null;
      story.metadata.agency = (dataObj.agency && dataObj.agency !== 'mint_print') ? dataObj.agency : null;
    }
    setTimeout(e => {
      callback(story, paraContent);
    }, 100);
    // });
  }

  openStoryEdit(item, language) {
    const url = this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, 'one_story')
      + '/' + item.id + '?domain=' + this.domain;
    let images = [];
    let key = null;
    if (item && item.story[0] && item.story[0].images && item.story[0].images.length > 0) {
      key = 'images';
      for (const image of item.story[0].images) {
        images.push(this.wireImageUrl + item.location + '/' + image);
      }
    }

    if (item && item.story[0] && item.story[0].listImages && item.story[0].listImages.length > 0) {
      key = 'listImages';
      for (const image of item.story[0].listImages) {
        images.push({
          'url': this.wireImageUrl + item.location + '/' + image.src,
          'caption': image.caption
        });
      }
    }
    this.showLoader = true;
    this.snowplowAnalytics(('/dash/story/new?refId=' + item.id), 'pick as story');
    this.restService.http_get(url)
      .subscribe(data => {
        data.targetLanguage = language;
        this.mapStoryObject(data, (story, paraContent) => {
          const wireId = String(story.wireFeedId).replace(' ', '');
          if (localStorage.getItem(wireId) !== null) {
            localStorage.removeItem(wireId);
          }
          localStorage.setItem(wireId, JSON.stringify(
            {
              'story': JSON.stringify(story),
              'para': paraContent,
              'images': JSON.stringify(images),
              'key': key,
              'originalData': JSON.stringify(data),
              'source': (this.byAgencyWire === 'notmint_print') ? 'AGENCY' : 'PRINT'
            }
          ));
          setTimeout(e2 => {
            window.open(window.location.origin + '/dash/story/new?refId=' + wireId + '&domain=' + this.domain, '_blank');
            this.showLoader = false;
          }, 70);
        });
      },
        error => {
          // console.log(error);
          this.showLoader = false;
          this.snotify.error('Story could not be loaded', '', this.sharedService.getConfig(false));
          this.router.navigate(['/dash/wire']);
        });

  }

  checkIfOnePublished(items) {
    for (const item of items.wirePublishedStories) {
      if (item.metadata && item.metadata.status && item.metadata.status === 'PUBLISHED') {
        return true;
      }
    }
    return false;
  }
  checkDomain(items) {
    for (const item of items.wirePublishedStories) {
      if (item.domainId === this.domain) {
        return true;
      }
    }
    return false;
  }

  translateStoryAsyn(contentData) {
    console.log(contentData);
    const translatedPreviewStory = $.extend(true, {}, contentData);
    return forkJoin(
      this.translateService.googleTranslateApi(contentData.headline, contentData.targetLanguage),
      this.translateService.googleTranslateApi(contentData.story[0].summary, contentData.targetLanguage),
      this.translateService.googleTranslateApi(contentData.story[0].content, contentData.targetLanguage)
    ).pipe(map((data: any) => {
      translatedPreviewStory.headline = data[0].text;
      translatedPreviewStory.story[0].summary = data[1].text;
      translatedPreviewStory.story[0].content = data[2].text;
      this.wirePreviewStory = translatedPreviewStory;
      return translatedPreviewStory;
    }));
  }

  fetchMore() {
    if (this.pages > this.pageNum + 1 && this.pageNum < 19) {
      const result = this.searchQuery.value;
      this.pageNum += 1;
      this.searchResults(result, this.pageNum, data => {
        if (data &&  data['content'] && data['content'].length > 0) {
          this.dataInsertion(data['content']);
          if (this.page_id === 'videoServiceStory') {
            this.multiList = this.createMultipleList(this.listArray);
          }
          this.noresults = false;
        } else {
          this.noresults = true;
        }
      });
    }
  }

  openUrl(url) {
    this.snowplowAnalytics('http://www.dereferer.org/?' + url, 'link click');
    window.open('http://www.dereferer.org/?' + url, '_blank');
  }
  createMultipleList(mainList) {
    if (mainList && mainList.length > 0) {
      let list = [];
      mainList.forEach((element, index) => {
        if (index !== 0 && index % 4 === 0) {
          this.multiList.push(list);
          list = [];
        }
        list.push(element);
      });
      if (list.length > 0 && this.multiList.length < 1) {
        this.multiList.push(list);
      }
    }
    return this.multiList;
  }

  ngOnDestroy() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect();
    }
    if (this.dragulaService.find('fifth-bag')) {
      this.dragulaService.destroy('fifth-bag');
    }
  }

  pdfDocumentLoaded(event) {
    if (document.getElementsByTagName('ng2-pdfjs-viewer')) {
      for (let j = 0; j < document.getElementsByTagName('ng2-pdfjs-viewer').length; j++) {
        if (document.getElementsByTagName('ng2-pdfjs-viewer')[j].getElementsByTagName('iframe')[0] &&
          document.getElementsByTagName('ng2-pdfjs-viewer')[j].
            getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0]) {
          const height = document.getElementsByTagName('ng2-pdfjs-viewer')[j].
            getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0].clientHeight;
          for (let i = 0; i < document.getElementsByClassName('container')[0].children.length; i++) {
            document.getElementsByClassName('container')[0].children[i].
              getElementsByClassName('dataField')[0].setAttribute('style', 'height:' + height + 'px;');
          }
        }
      }
    }
  }

  snowplowAnalytics(url, name) {
    if (this.page_id === 'wires') {
      this.sharedService.analyticsCall((window.location.origin + url), 'Agency Feed', [], name);
    } else if (this.page_id === 'print_wires') {
      this.sharedService.analyticsCall((window.location.origin + url), 'Print Feed', [], name);
    } else if (this.page_id === 'pulse_wires') {
      this.sharedService.analyticsCall((window.location.origin + url), 'Competition Feed', [], name);
    }
  }

  videoPickEvent(url) {
    if (this.page_id === 'videoStory') {
      this.sharedService.analyticsCall((window.location.origin + url), 'Video Service', [], 'pick as story');
    } else if (this.page_id === 'videoServiceStory') {
      this.sharedService.analyticsCall((window.location.origin + url), 'Video Stories', [], 'edit');
    }
  }
  pickElementForStory(id) {
    this.sendIdToParentfn.emit(id);
  }

  clickAction(item) {
    if (this.isPickEnabled) {
      this.pickElementForStory(item.id);
    } else if (this.routeLinkForList !== 'false') {
      // console.log(this.routeLinkForList  '/'  item.id, item);
      this.router.navigate([(this.routeLinkForList + '/' + item.id)], { queryParams: { domain: this.domain } });
    }
  }
  showSubNav() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['pages'] && this.domainConfig['config']['pages']['showSubNav'] === 'true');
  }


  measureTime(count) {
    if (this.listData && this.listData['length'] === this.pageSize) {
      this.timings.list = performance.now();
      console.log('list loaded => ', performance.now() - this.timings.resp);
      console.log('total first load time => ', performance.now() - this.timings.constr);
    } else if (count < 6) {
      setTimeout(e => {
        this.measureTime(++count);
      }, 0);
    }
  }




  // @HostListener('document:click', ['$event']) onDocumentClick(event) {
  //   // this.focusOut('null');
  //   event.stopPropagation()  
  // }

  focusInSuggest(model) {
    console.log(model);
    if (model === 'publisher') {
      this.insidePublisher = true;
      if (this.selectedPublisherQuery === '') {
        this.filteredPublisherSuggestion = this.publisherSuggestion;
      }
    }
  }

  focusOut(model) {
    if (model === 'publisher') {
      this.insidePublisher = false;
      this.filteredPublisherSuggestion = [];
    }
  }

  filterAutoCompleteUp(event, model) {
    if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter') {
      if (model === 'publisher') {
        if (this.insidePublisher) {
          if (this.selectedPublisherQuery && this.selectedPublisherQuery.length > 0) {
            this.filteredPublisherSuggestion = this.publisherSuggestion.filter(e => {
              return e.name.toLowerCase().includes(this.selectedPublisherQuery.toLowerCase())
            });
          } else {
            this.filteredPublisherSuggestion = this.publisherSuggestion;
          }
        } else {
          this.insidePublisher = true;
          this.filteredPublisherSuggestion = [];
        }
      }
    }
    
    return true;
  }

  selectPublisher(publisher, specialCase) {
    if(specialCase || this.selectedPublisher === null || (this.selectedPublisher !== null && publisher.id !== this.selectedPublisher.id)) {
      this.str = '';
      this.endPendingSubscriptions();
      this.insideSearchByKeyWord = false;
      this.selectedPodcastPublisher = publisher;
      const url = environment.product.podcastBaseUrl + '/podcastbypublisher/' + publisher.id + '/?page=1&limit=10000';
      this.podcastEpisodesList = [];

      this.insidePublisher = false;
      this.filteredPublisherSuggestion = [];

      this.selectedPublisherQuery = publisher.name;
      this.selectedPublisher = publisher;
      this.restService.http_get(url)
      .subscribe(
        data => {
          this.podcastList = data.data.podcasts;
          this.fetchPodcastEpisodes();
        },
        error => {
          console.log(error);
        });
    }
    this.selectedPublisherQuery = publisher.name;
  }

  fetchPodcastEpisodes() {
    this.podcastEpisodesList = [];
    this.podcastList.forEach(pod => {
      const url = environment.product.podcastBaseUrl + '/episodes/' + pod.id + '/?page=1&limit=10000';
      this.restService.http_get(url)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        data => {
          let obj = {
            podcast: pod,
            episodes: data.data.episodes
          };
          this.podcastEpisodesList.push(obj);
        },
        error => {
          console.log(error);
        });
    });

  }

  searchEpisodesByKeyWords(keyword) {
    this.endPendingSubscriptions();
    this.insideSearchByKeyWord = true;
    keyword = keyword.trim();

    if(keyword && keyword.length < 1){
      this.selectPublisher(this.selectedPodcastPublisher, true)
    } else {
      this.podcastEpisodesList = [];
      const url = environment.product.podcastBaseUrl + '/searchbypublisher/'+this.selectedPublisher.id+'/?search=' + keyword + '&page=1&limit=1000';
      this.restService.http_get(url)
        .subscribe(
          data => {
            let obj = {
              podcast: {title:'Search Result', id:0},
              episodes: data.data.episodes
            };
            this.podcastEpisodesList.push(obj);
            console.log('search result : ', this.podcastEpisodesList);
          },
          error => {
            console.log(error);
          });
    }

  }

  endPendingSubscriptions() {
    this.ngUnsubscribe.next();
  }

  downloadPixabayImage(imageLargeUrl) {
    const imageUrl = imageLargeUrl;
    this.http.get(imageUrl, { responseType: 'blob' }).subscribe(
      (response) => {
        saveAs(response, imageLargeUrl);
      },
      (error) => {
        console.error('Error occurred while downloading the image:', error);
      }
    );
  }

  formatSize(sizeInBytes: number): string {
    if (sizeInBytes < 1024) {
      return sizeInBytes + ' B';
    } else if (sizeInBytes < 1024 * 1024) {
      const sizeInKB = sizeInBytes / 1024;
      return sizeInKB.toFixed(2) + ' KB';
    } else {
      const sizeInMB = sizeInBytes / (1024 * 1024);
      return sizeInMB.toFixed(2) + ' MB';
    }
  }


}